import { createAsyncThunk as qu, createSlice as e_ } from "@reduxjs/toolkit";
import ko, { createContext as n_, useContext as t_, useEffect as pi } from "react";
import { useSelector as ft } from "react-redux";
import { useNavigate as r_, useSearchParams as i_ } from "react-router-dom";
class cr extends Error {
}
cr.prototype.name = "InvalidTokenError";
function u_(c) {
  return decodeURIComponent(atob(c).replace(/(.)/g, (o, i) => {
    let _ = i.charCodeAt(0).toString(16).toUpperCase();
    return _.length < 2 && (_ = "0" + _), "%" + _;
  }));
}
function a_(c) {
  let o = c.replace(/-/g, "+").replace(/_/g, "/");
  switch (o.length % 4) {
    case 0:
      break;
    case 2:
      o += "==";
      break;
    case 3:
      o += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return u_(o);
  } catch {
    return atob(o);
  }
}
function $o(c, o) {
  if (typeof c != "string")
    throw new cr("Invalid token specified: must be a string");
  o || (o = {});
  const i = o.header === !0 ? 0 : 1, _ = c.split(".")[i];
  if (typeof _ != "string")
    throw new cr(`Invalid token specified: missing part #${i + 1}`);
  let w;
  try {
    w = a_(_);
  } catch (R) {
    throw new cr(`Invalid token specified: invalid base64 for part #${i + 1} (${R.message})`);
  }
  try {
    return JSON.parse(w);
  } catch (R) {
    throw new cr(`Invalid token specified: invalid json for part #${i + 1} (${R.message})`);
  }
}
var gn = /* @__PURE__ */ ((c) => (c.ANONYMOUS = "anonymous", c.PENDING = "pending", c.AUTHORIZED = "authorized", c))(gn || {});
function f_() {
  const c = localStorage.getItem("access_token"), o = localStorage.getItem("refresh_token"), i = o && Zu(o);
  return !(!c || !o || !i || !Number(i) || Number.isNaN(Number(i)) || Ju() > i);
}
const o_ = () => f_() ? "authorized" : "anonymous";
function s_(c) {
  if (!c)
    return !1;
  const o = Zu(c);
  return Ju() < o;
}
const Go = (c) => {
  const { idToken: o, accessToken: i, refreshToken: _ } = c, w = l_(i) - (/* @__PURE__ */ new Date()).getTime();
  localStorage.setItem("server_time_offset", String(w)), localStorage.setItem("id_token", o), localStorage.setItem("access_token", i), localStorage.setItem("refresh_token", _);
}, c_ = () => {
  localStorage.removeItem("access_token"), localStorage.removeItem("refresh_token"), localStorage.removeItem("id_token"), localStorage.removeItem("server_time_offset"), sessionStorage.removeItem("code_verifier");
};
var dn = /* @__PURE__ */ ((c) => (c.SessionExpired = "error-session-expired", c.OidcConfiguration = "error-oidc-configuration", c.SystemCurrentlyUnavailable = "error-system-currently-unavailable", c.RefreshTokenFailed = "refresh-token-failed", c.CodeCallbackFailed = "code-callback-failed", c.LoginUserFailed = "login-user-failed", c))(dn || {});
const Zu = (c) => $o(c).exp * 1e3, l_ = (c) => $o(c).iat * 1e3, Ju = () => {
  const c = Number(localStorage.getItem("server_time_offset")) || 0;
  return (/* @__PURE__ */ new Date()).getTime() + c;
}, h_ = (c) => {
  const i = Zu(c), _ = Ju(), w = i - _;
  return Math.max(w - 3e4, 0);
}, ot = (c) => ({
  name: c.name || "unable_to_fetch",
  message: String(c.message) || "Failed to fetch",
  status: c.status || 503,
  stack: c.stack
}), g_ = 43, d_ = {
  async generate() {
    let c = sessionStorage.getItem("code_verifier");
    return c || (c = this.generateVerifier(g_), sessionStorage.setItem("code_verifier", c)), this.generateChallenge(c);
  },
  async generateChallenge(c) {
    const o = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(c));
    return zo(new Uint8Array(o));
  },
  generateVerifier(c) {
    const o = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-._~", i = window.crypto.getRandomValues(new Uint8Array(c));
    let _ = "";
    for (let w = 0; w < c; w++)
      _ += o[i[w] % o.length];
    return _;
  }
}, zo = (c) => {
  const o = Array.from(new Uint8Array(c), (i) => String.fromCharCode(i)).join("");
  return window.btoa(o).replace(/\//g, "_").replace(/\+/g, "-").replace(/=/g, "");
}, So = "0p3nT@lk!", tv = {
  keyCharAt(c) {
    return So.charCodeAt(Math.floor(c % So.length));
  },
  fromBase64String(c) {
    const o = window.atob(c.replace(/_/g, "/").replace(/-/g, "+")), i = o.length, _ = new Uint8Array(i);
    for (let w = 0; w < i; w++)
      _[w] = o.charCodeAt(w);
    return _;
  },
  xorProcess(c) {
    const o = new Uint8Array(c.length);
    for (let i = 0; i < c.length; i++)
      o[i] = c[i] ^ this.keyCharAt(i);
    return o;
  },
  handle(c) {
    try {
      const o = this.fromBase64String(c), i = this.xorProcess(o);
      return new TextDecoder().decode(i);
    } catch {
      const o = new TextEncoder().encode(c), i = this.xorProcess(o);
      return zo(i);
    }
  }
}, Ho = (c) => typeof c == "object" && c !== null, To = (c) => Ho(c) && !(c instanceof RegExp) && !(c instanceof Error) && !(c instanceof Date), p_ = Symbol("mapObjectSkip"), zu = (c, o, i, _ = /* @__PURE__ */ new WeakMap()) => {
  if (i = {
    deep: !1,
    target: {},
    ...i
  }, _.has(c))
    return _.get(c);
  _.set(c, i.target);
  const { target: w } = i;
  delete i.target;
  const R = (T) => T.map((F) => To(F) ? zu(F, o, i, _) : F);
  if (Array.isArray(c))
    return R(c);
  for (const [T, F] of Object.entries(c)) {
    const b = o(T, F, c);
    if (b === p_)
      continue;
    let [K, L, { shouldRecurse: B = !0 } = {}] = b;
    K !== "__proto__" && (i.deep && B && To(L) && (L = Array.isArray(L) ? R(L) : zu(L, o, i, _)), w[K] = L);
  }
  return w;
};
function Co(c, o, i) {
  if (!Ho(c))
    throw new TypeError(`Expected an object, got \`${c}\` (${typeof c})`);
  return zu(c, o, i);
}
const __ = /[\p{Lu}]/u, v_ = /[\p{Ll}]/u, Io = /^[\p{Lu}](?![\p{Lu}])/gu, Yo = /([\p{Alpha}\p{N}_]|$)/u, Xu = /[_.\- ]+/, w_ = new RegExp("^" + Xu.source), bo = new RegExp(Xu.source + Yo.source, "gu"), Oo = new RegExp("\\d+" + Yo.source, "gu"), m_ = (c, o, i, _) => {
  let w = !1, R = !1, T = !1, F = !1;
  for (let b = 0; b < c.length; b++) {
    const K = c[b];
    F = b > 2 ? c[b - 3] === "-" : !0, w && __.test(K) ? (c = c.slice(0, b) + "-" + c.slice(b), w = !1, T = R, R = !0, b++) : R && T && v_.test(K) && (!F || _) ? (c = c.slice(0, b - 1) + "-" + c.slice(b - 1), T = R, R = !1, w = !0) : (w = o(K) === K && i(K) !== K, T = R, R = i(K) === K && o(K) !== K);
  }
  return c;
}, x_ = (c, o) => (Io.lastIndex = 0, c.replaceAll(Io, (i) => o(i))), E_ = (c, o) => (bo.lastIndex = 0, Oo.lastIndex = 0, c.replaceAll(Oo, (i, _, w) => ["_", "-"].includes(c.charAt(w + i.length)) ? i : o(i)).replaceAll(bo, (i, _) => o(_)));
function y_(c, o) {
  if (!(typeof c == "string" || Array.isArray(c)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (o = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...o
  }, Array.isArray(c) ? c = c.map((R) => R.trim()).filter((R) => R.length).join("-") : c = c.trim(), c.length === 0)
    return "";
  const i = o.locale === !1 ? (R) => R.toLowerCase() : (R) => R.toLocaleLowerCase(o.locale), _ = o.locale === !1 ? (R) => R.toUpperCase() : (R) => R.toLocaleUpperCase(o.locale);
  return c.length === 1 ? Xu.test(c) ? "" : o.pascalCase ? _(c) : i(c) : (c !== i(c) && (c = m_(c, i, _, o.preserveConsecutiveUppercase)), c = c.replace(w_, ""), c = o.preserveConsecutiveUppercase ? x_(c, i) : i(c), o.pascalCase && (c = _(c.charAt(0)) + c.slice(1)), E_(c, _));
}
class R_ extends Map {
  constructor(o = {}) {
    if (super(), !(o.maxSize && o.maxSize > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    if (typeof o.maxAge == "number" && o.maxAge === 0)
      throw new TypeError("`maxAge` must be a number greater than 0");
    this.maxSize = o.maxSize, this.maxAge = o.maxAge || Number.POSITIVE_INFINITY, this.onEviction = o.onEviction, this.cache = /* @__PURE__ */ new Map(), this.oldCache = /* @__PURE__ */ new Map(), this._size = 0;
  }
  // TODO: Use private class methods when targeting Node.js 16.
  _emitEvictions(o) {
    if (typeof this.onEviction == "function")
      for (const [i, _] of o)
        this.onEviction(i, _.value);
  }
  _deleteIfExpired(o, i) {
    return typeof i.expiry == "number" && i.expiry <= Date.now() ? (typeof this.onEviction == "function" && this.onEviction(o, i.value), this.delete(o)) : !1;
  }
  _getOrDeleteIfExpired(o, i) {
    if (this._deleteIfExpired(o, i) === !1)
      return i.value;
  }
  _getItemValue(o, i) {
    return i.expiry ? this._getOrDeleteIfExpired(o, i) : i.value;
  }
  _peek(o, i) {
    const _ = i.get(o);
    return this._getItemValue(o, _);
  }
  _set(o, i) {
    this.cache.set(o, i), this._size++, this._size >= this.maxSize && (this._size = 0, this._emitEvictions(this.oldCache), this.oldCache = this.cache, this.cache = /* @__PURE__ */ new Map());
  }
  _moveToRecent(o, i) {
    this.oldCache.delete(o), this._set(o, i);
  }
  *_entriesAscending() {
    for (const o of this.oldCache) {
      const [i, _] = o;
      this.cache.has(i) || this._deleteIfExpired(i, _) === !1 && (yield o);
    }
    for (const o of this.cache) {
      const [i, _] = o;
      this._deleteIfExpired(i, _) === !1 && (yield o);
    }
  }
  get(o) {
    if (this.cache.has(o)) {
      const i = this.cache.get(o);
      return this._getItemValue(o, i);
    }
    if (this.oldCache.has(o)) {
      const i = this.oldCache.get(o);
      if (this._deleteIfExpired(o, i) === !1)
        return this._moveToRecent(o, i), i.value;
    }
  }
  set(o, i, { maxAge: _ = this.maxAge } = {}) {
    const w = typeof _ == "number" && _ !== Number.POSITIVE_INFINITY ? Date.now() + _ : void 0;
    return this.cache.has(o) ? this.cache.set(o, {
      value: i,
      expiry: w
    }) : this._set(o, { value: i, expiry: w }), this;
  }
  has(o) {
    return this.cache.has(o) ? !this._deleteIfExpired(o, this.cache.get(o)) : this.oldCache.has(o) ? !this._deleteIfExpired(o, this.oldCache.get(o)) : !1;
  }
  peek(o) {
    if (this.cache.has(o))
      return this._peek(o, this.cache);
    if (this.oldCache.has(o))
      return this._peek(o, this.oldCache);
  }
  delete(o) {
    const i = this.cache.delete(o);
    return i && this._size--, this.oldCache.delete(o) || i;
  }
  clear() {
    this.cache.clear(), this.oldCache.clear(), this._size = 0;
  }
  resize(o) {
    if (!(o && o > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    const i = [...this._entriesAscending()], _ = i.length - o;
    _ < 0 ? (this.cache = new Map(i), this.oldCache = /* @__PURE__ */ new Map(), this._size = i.length) : (_ > 0 && this._emitEvictions(i.slice(0, _)), this.oldCache = new Map(i.slice(_)), this.cache = /* @__PURE__ */ new Map(), this._size = 0), this.maxSize = o;
  }
  *keys() {
    for (const [o] of this)
      yield o;
  }
  *values() {
    for (const [, o] of this)
      yield o;
  }
  *[Symbol.iterator]() {
    for (const o of this.cache) {
      const [i, _] = o;
      this._deleteIfExpired(i, _) === !1 && (yield [i, _.value]);
    }
    for (const o of this.oldCache) {
      const [i, _] = o;
      this.cache.has(i) || this._deleteIfExpired(i, _) === !1 && (yield [i, _.value]);
    }
  }
  *entriesDescending() {
    let o = [...this.cache];
    for (let i = o.length - 1; i >= 0; --i) {
      const _ = o[i], [w, R] = _;
      this._deleteIfExpired(w, R) === !1 && (yield [w, R.value]);
    }
    o = [...this.oldCache];
    for (let i = o.length - 1; i >= 0; --i) {
      const _ = o[i], [w, R] = _;
      this.cache.has(w) || this._deleteIfExpired(w, R) === !1 && (yield [w, R.value]);
    }
  }
  *entriesAscending() {
    for (const [o, i] of this._entriesAscending())
      yield [o, i.value];
  }
  get size() {
    if (!this._size)
      return this.oldCache.size;
    let o = 0;
    for (const i of this.oldCache.keys())
      this.cache.has(i) || o++;
    return Math.min(this._size + o, this.maxSize);
  }
  entries() {
    return this.entriesAscending();
  }
  forEach(o, i = this) {
    for (const [_, w] of this.entriesAscending())
      o.call(i, w, _, this);
  }
  get [Symbol.toStringTag]() {
    return JSON.stringify([...this.entriesAscending()]);
  }
}
const A_ = (c, o) => c.some((i) => typeof i == "string" ? i === o : (i.lastIndex = 0, i.test(o))), $u = new R_({ maxSize: 1e5 }), Lo = (c) => typeof c == "object" && c !== null && !(c instanceof RegExp) && !(c instanceof Error) && !(c instanceof Date), Po = (c, o = {}) => {
  if (!Lo(c))
    return c;
  const {
    exclude: i,
    pascalCase: _ = !1,
    stopPaths: w,
    deep: R = !1,
    preserveConsecutiveUppercase: T = !1
  } = o, F = new Set(w), b = (K) => (L, B) => {
    if (R && Lo(B)) {
      const j = K === void 0 ? L : `${K}.${L}`;
      F.has(j) || (B = Co(B, b(j)));
    }
    if (!(i && A_(i, L))) {
      const j = _ ? `${L}_` : L;
      if ($u.has(j))
        L = $u.get(j);
      else {
        const oe = y_(L, { pascalCase: _, locale: !1, preserveConsecutiveUppercase: T });
        L.length < 100 && $u.set(j, oe), L = oe;
      }
    }
    return [L, B];
  };
  return Co(c, b(void 0));
};
function vi(c, o) {
  return Array.isArray(c) ? Object.keys(c).map((i) => Po(c[i], o)) : Po(c, o);
}
var li = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function S_(c) {
  return c && c.__esModule && Object.prototype.hasOwnProperty.call(c, "default") ? c.default : c;
}
function T_(c) {
  if (Object.prototype.hasOwnProperty.call(c, "__esModule")) return c;
  var o = c.default;
  if (typeof o == "function") {
    var i = function _() {
      return this instanceof _ ? Reflect.construct(o, arguments, this.constructor) : o.apply(this, arguments);
    };
    i.prototype = o.prototype;
  } else i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(c).forEach(function(_) {
    var w = Object.getOwnPropertyDescriptor(c, _);
    Object.defineProperty(i, _, w.get ? w : {
      enumerable: !0,
      get: function() {
        return c[_];
      }
    });
  }), i;
}
var hi = { exports: {} }, Uo;
function C_() {
  if (Uo) return hi.exports;
  Uo = 1;
  const c = (w) => typeof w == "object" && w !== null, o = Symbol("skip"), i = (w) => c(w) && !(w instanceof RegExp) && !(w instanceof Error) && !(w instanceof Date), _ = (w, R, T, F = /* @__PURE__ */ new WeakMap()) => {
    if (T = {
      deep: !1,
      target: {},
      ...T
    }, F.has(w))
      return F.get(w);
    F.set(w, T.target);
    const { target: b } = T;
    delete T.target;
    const K = (L) => L.map((B) => i(B) ? _(B, R, T, F) : B);
    if (Array.isArray(w))
      return K(w);
    for (const [L, B] of Object.entries(w)) {
      const j = R(L, B, w);
      if (j === o)
        continue;
      let [oe, se, { shouldRecurse: ve = !0 } = {}] = j;
      oe !== "__proto__" && (T.deep && ve && i(se) && (se = Array.isArray(se) ? K(se) : _(se, R, T, F)), b[oe] = se);
    }
    return b;
  };
  return hi.exports = (w, R, T) => {
    if (!c(w))
      throw new TypeError(`Expected an object, got \`${w}\` (${typeof w})`);
    return _(w, R, T);
  }, hi.exports.mapObjectSkip = o, hi.exports;
}
var _i = function() {
  return _i = Object.assign || function(o) {
    for (var i, _ = 1, w = arguments.length; _ < w; _++) {
      i = arguments[_];
      for (var R in i) Object.prototype.hasOwnProperty.call(i, R) && (o[R] = i[R]);
    }
    return o;
  }, _i.apply(this, arguments);
};
function I_(c) {
  return c.toLowerCase();
}
var b_ = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], O_ = /[^A-Z0-9]+/gi;
function L_(c, o) {
  o === void 0 && (o = {});
  for (var i = o.splitRegexp, _ = i === void 0 ? b_ : i, w = o.stripRegexp, R = w === void 0 ? O_ : w, T = o.transform, F = T === void 0 ? I_ : T, b = o.delimiter, K = b === void 0 ? " " : b, L = Do(Do(c, _, "$1\0$2"), R, "\0"), B = 0, j = L.length; L.charAt(B) === "\0"; )
    B++;
  for (; L.charAt(j - 1) === "\0"; )
    j--;
  return L.slice(B, j).split("\0").map(F).join(K);
}
function Do(c, o, i) {
  return o instanceof RegExp ? c.replace(o, i) : o.reduce(function(_, w) {
    return _.replace(w, i);
  }, c);
}
function P_(c, o) {
  return o === void 0 && (o = {}), L_(c, _i({ delimiter: "." }, o));
}
function U_(c, o) {
  return o === void 0 && (o = {}), P_(c, _i({ delimiter: "_" }, o));
}
const D_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  snakeCase: U_
}, Symbol.toStringTag, { value: "Module" })), F_ = /* @__PURE__ */ T_(D_);
var Gu, Fo;
function M_() {
  if (Fo) return Gu;
  Fo = 1;
  const c = C_(), { snakeCase: o } = F_, i = {}.constructor;
  Gu = function(R, T) {
    if (Array.isArray(R)) {
      if (R.some((F) => F.constructor !== i))
        throw new Error("obj must be array of plain objects");
    } else if (R.constructor !== i)
      throw new Error("obj must be an plain object");
    return T = Object.assign({ deep: !0, exclude: [], parsingOptions: {} }, T), c(R, function(F, b) {
      return [
        _(T.exclude, F) ? F : o(F, T.parsingOptions),
        b,
        w(F, b, T)
      ];
    }, T);
  };
  function _(R, T) {
    return R.some(function(F) {
      return typeof F == "string" ? F === T : F.test(T);
    });
  }
  function w(R, T, F) {
    return F.shouldRecurse ? { shouldRecurse: F.shouldRecurse(R, T) } : void 0;
  }
  return Gu;
}
var W_ = M_();
const Vu = /* @__PURE__ */ S_(W_), hr = qu("user/login", async (c, { rejectWithValue: o }) => {
  try {
    const i = await fetch(new URL("v1/auth/login", c.baseUrl).toString(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(Vu({ idToken: c.idToken }))
    });
    return i.ok ? vi(await i.json(), { deep: !0 }) : o(
      ot({
        name: dn.LoginUserFailed,
        message: i.statusText,
        status: i.status
      })
    );
  } catch (i) {
    if (i instanceof SyntaxError)
      throw console.debug("There was a SyntaxError", i), new Error(String(i));
    return o(
      ot({ name: dn.LoginUserFailed, message: i, status: 503 })
    );
  }
}), Hu = qu(
  "auth/code_callback",
  async (c, { rejectWithValue: o, dispatch: i }) => {
    try {
      const _ = sessionStorage.getItem("code_verifier"), w = {
        grantType: "authorization_code",
        clientId: c.clientId,
        redirectUri: c.redirectUri,
        code: c.code,
        codeVerifier: _ || ""
      }, R = await fetch(c.tokenEndpoint, {
        method: "POST",
        body: new URLSearchParams(Vu(w))
      });
      if (!R.ok)
        return o(
          ot({
            name: dn.CodeCallbackFailed,
            message: R.statusText,
            status: R.status
          })
        );
      const T = vi(await R.json(), { deep: !0 });
      return Go(T), c.baseUrl && await i(hr({ idToken: T.idToken, baseUrl: c.baseUrl })), T;
    } catch (_) {
      if (_ instanceof SyntaxError)
        throw console.debug("There was a SyntaxError", _), new Error(String(_));
      return o(
        ot({
          name: dn.CodeCallbackFailed,
          message: "Unable to fetch code callback api",
          status: 503
        })
      );
    }
  }
), di = qu(
  "auth/get_new_token",
  async (c, { rejectWithValue: o, dispatch: i }) => {
    const _ = localStorage.getItem("refresh_token");
    if (!_)
      return console.debug("No refresh token found"), o(
        ot({
          name: dn.RefreshTokenFailed,
          message: "Refresh token not present",
          status: 503
        })
      );
    try {
      const w = await fetch(c.tokenEndpoint, {
        body: new URLSearchParams(
          Vu({
            grantType: "refresh_token",
            clientId: c.clientId,
            refreshToken: _
          })
        ),
        method: "POST"
      });
      if (!w.ok)
        return o(
          ot({
            name: dn.RefreshTokenFailed,
            message: w.statusText,
            status: w.status
          })
        );
      const R = vi(await w.json(), { deep: !0 });
      return Go(R), c.baseUrl && i(hr({ idToken: R.idToken, baseUrl: c.baseUrl })), R;
    } catch (w) {
      if (w instanceof SyntaxError)
        throw console.debug("There was a SyntaxError", w), new Error(String(w));
      return o(
        ot({
          name: dn.RefreshTokenFailed,
          message: "Refresh token not present",
          status: 503
        })
      );
    }
  }
);
let Yu;
const rv = (c) => {
  Yu = c;
}, Ko = () => {
  if (Yu)
    return Yu;
  throw new Error("[redux-oidc]: The dispatch function has not been setup");
}, N_ = {
  state: o_(),
  loginTimestamp: void 0,
  refreshTokenLoading: !1,
  loading: !1
}, qo = e_({
  name: "auth",
  initialState: N_,
  reducers: {
    authorize: (c) => {
      c.state = gn.AUTHORIZED;
    },
    startLoading: (c) => {
      c.state = gn.PENDING;
    },
    logout: (c) => {
      c.state = gn.ANONYMOUS;
    },
    authError: (c, { payload: o }) => {
      c.error = o;
    }
  },
  extraReducers: (c) => {
    c.addCase(Hu.pending, (o) => {
      o.state = gn.PENDING;
    }).addCase(Hu.rejected, (o, { payload: i }) => {
      o.state = gn.ANONYMOUS, o.error = i, o.loading = !1;
    }).addCase(hr.pending, (o) => {
      o.error = void 0;
    }).addCase(hr.fulfilled, (o) => {
      o.state = gn.AUTHORIZED, o.error = void 0, o.loginTimestamp = (/* @__PURE__ */ new Date()).toISOString();
    }).addCase(hr.rejected, (o, { payload: i }) => {
      o.state = gn.ANONYMOUS, o.error = i;
    }).addCase(di.pending, (o) => {
      o.refreshTokenLoading = !0;
    }).addCase(di.fulfilled, (o) => {
      o.refreshTokenLoading = !1;
    }).addCase(di.rejected, (o, { payload: i }) => {
      o.refreshTokenLoading = !1, o.error = i, o.state = gn.ANONYMOUS;
    });
  }
}), { authorize: iv, logout: uv, startLoading: B_, authError: av } = qo.actions, k_ = (c) => c.auth.refreshTokenLoading, $_ = (c) => c.auth.loginTimestamp, fv = (c) => c.auth.loginTimestamp === void 0, Zo = (c) => c.auth.state === "authorized", G_ = (c) => c.auth.state === gn.PENDING, z_ = (c) => c.auth.error, H_ = (c) => {
  var o;
  return ((o = c.auth.error) == null ? void 0 : o.name) === dn.RefreshTokenFailed;
}, ov = qo.reducer;
class Ut {
  constructor(o) {
    this.getConfigurationEndpoints = async () => (this._oidcConfiguration || (this._oidcConfiguration = await this.fetchOidcConfig()), this._oidcConfiguration), this.getSavedLocation = () => sessionStorage.getItem("saved_location") || void 0, this.saveLocationForRedirect = (i) => sessionStorage.setItem("saved_location", i), this.getAccessToken = () => localStorage.getItem("access_token"), this.getIdToken = () => localStorage.getItem("id_token"), this._configuration = o;
  }
  static getInstance(o) {
    return Ut._instance || (Ut._instance = new Ut(o)), Ut._instance;
  }
  async fetchOidcConfig() {
    try {
      const o = await fetch(new URL(`${this._configuration.authority}/.well-known/openid-configuration`));
      if (!o.ok)
        throw `OIDC config not available. Status: ${o.status} ${o.statusText}`;
      if (o.body === null)
        throw `OIDC config empty. Response: ${o} (${o.status} ${o.statusText})`;
      return vi(await o.json(), { deep: !0 });
    } catch (o) {
      throw o instanceof SyntaxError && console.debug("Syntax error during OIDC config fetch", o), new Error(String(o));
    }
  }
  getBaseUrl() {
    return this._configuration.baseUrl;
  }
  async getLoginUrl(o) {
    const { authorizationEndpoint: i } = await this.getConfigurationEndpoints(), _ = new URL(i);
    return _.searchParams.append("response_type", "code"), _.searchParams.append("client_id", this._configuration.clientId), _.searchParams.append("redirect_uri", this._configuration.redirectUri), _.searchParams.append("scope", this._configuration.scope), o && (_.searchParams.append("code_challenge", o), _.searchParams.append("code_challenge_method", "S256")), _;
  }
  /**
   * Redirect user to sign in provider
   */
  async startOidcSignIn(o = window.location.pathname, i) {
    this.saveLocationForRedirect(o), window.location.replace(await this.getLoginUrl(i));
  }
  async signOut(o) {
    const { endSessionEndpoint: i } = await this.getConfigurationEndpoints(), _ = new URL(i);
    _.searchParams.append("client_id", this._configuration.clientId);
    const w = localStorage.getItem("id_token");
    w && _.searchParams.append("id_token_hint", w), _.searchParams.append(
      "post_logout_redirect_uri",
      o || this._configuration.signOutRedirectUri
    ), window.location.replace(_), c_();
  }
}
var gi = { exports: {} }, or = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mo;
function Y_() {
  if (Mo) return or;
  Mo = 1;
  var c = ko, o = Symbol.for("react.element"), i = Symbol.for("react.fragment"), _ = Object.prototype.hasOwnProperty, w = c.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, R = { key: !0, ref: !0, __self: !0, __source: !0 };
  function T(F, b, K) {
    var L, B = {}, j = null, oe = null;
    K !== void 0 && (j = "" + K), b.key !== void 0 && (j = "" + b.key), b.ref !== void 0 && (oe = b.ref);
    for (L in b) _.call(b, L) && !R.hasOwnProperty(L) && (B[L] = b[L]);
    if (F && F.defaultProps) for (L in b = F.defaultProps, b) B[L] === void 0 && (B[L] = b[L]);
    return { $$typeof: o, type: F, key: j, ref: oe, props: B, _owner: w.current };
  }
  return or.Fragment = i, or.jsx = T, or.jsxs = T, or;
}
var sr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wo;
function K_() {
  return Wo || (Wo = 1, process.env.NODE_ENV !== "production" && function() {
    var c = ko, o = Symbol.for("react.element"), i = Symbol.for("react.portal"), _ = Symbol.for("react.fragment"), w = Symbol.for("react.strict_mode"), R = Symbol.for("react.profiler"), T = Symbol.for("react.provider"), F = Symbol.for("react.context"), b = Symbol.for("react.forward_ref"), K = Symbol.for("react.suspense"), L = Symbol.for("react.suspense_list"), B = Symbol.for("react.memo"), j = Symbol.for("react.lazy"), oe = Symbol.for("react.offscreen"), se = Symbol.iterator, ve = "@@iterator";
    function we(l) {
      if (l === null || typeof l != "object")
        return null;
      var y = se && l[se] || l[ve];
      return typeof y == "function" ? y : null;
    }
    var Ae = c.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function pe(l) {
      {
        for (var y = arguments.length, S = new Array(y > 1 ? y - 1 : 0), D = 1; D < y; D++)
          S[D - 1] = arguments[D];
        Ve("error", l, S);
      }
    }
    function Ve(l, y, S) {
      {
        var D = Ae.ReactDebugCurrentFrame, Z = D.getStackAddendum();
        Z !== "" && (y += "%s", S = S.concat([Z]));
        var X = S.map(function(H) {
          return String(H);
        });
        X.unshift("Warning: " + y), Function.prototype.apply.call(console[l], console, X);
      }
    }
    var zn = !1, Qe = !1, Hn = !1, je = !1, Yn = !1, st;
    st = Symbol.for("react.module.reference");
    function wi(l) {
      return !!(typeof l == "string" || typeof l == "function" || l === _ || l === R || Yn || l === w || l === K || l === L || je || l === oe || zn || Qe || Hn || typeof l == "object" && l !== null && (l.$$typeof === j || l.$$typeof === B || l.$$typeof === T || l.$$typeof === F || l.$$typeof === b || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      l.$$typeof === st || l.getModuleId !== void 0));
    }
    function mi(l, y, S) {
      var D = l.displayName;
      if (D)
        return D;
      var Z = y.displayName || y.name || "";
      return Z !== "" ? S + "(" + Z + ")" : S;
    }
    function gr(l) {
      return l.displayName || "Context";
    }
    function an(l) {
      if (l == null)
        return null;
      if (typeof l.tag == "number" && pe("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof l == "function")
        return l.displayName || l.name || null;
      if (typeof l == "string")
        return l;
      switch (l) {
        case _:
          return "Fragment";
        case i:
          return "Portal";
        case R:
          return "Profiler";
        case w:
          return "StrictMode";
        case K:
          return "Suspense";
        case L:
          return "SuspenseList";
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case F:
            var y = l;
            return gr(y) + ".Consumer";
          case T:
            var S = l;
            return gr(S._context) + ".Provider";
          case b:
            return mi(l, l.render, "ForwardRef");
          case B:
            var D = l.displayName || null;
            return D !== null ? D : an(l.type) || "Memo";
          case j: {
            var Z = l, X = Z._payload, H = Z._init;
            try {
              return an(H(X));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var fn = Object.assign, Kn = 0, dr, qn, pn, pr, Zn, Ue, _r;
    function vr() {
    }
    vr.__reactDisabledLog = !0;
    function xi() {
      {
        if (Kn === 0) {
          dr = console.log, qn = console.info, pn = console.warn, pr = console.error, Zn = console.group, Ue = console.groupCollapsed, _r = console.groupEnd;
          var l = {
            configurable: !0,
            enumerable: !0,
            value: vr,
            writable: !0
          };
          Object.defineProperties(console, {
            info: l,
            log: l,
            warn: l,
            error: l,
            group: l,
            groupCollapsed: l,
            groupEnd: l
          });
        }
        Kn++;
      }
    }
    function In() {
      {
        if (Kn--, Kn === 0) {
          var l = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: fn({}, l, {
              value: dr
            }),
            info: fn({}, l, {
              value: qn
            }),
            warn: fn({}, l, {
              value: pn
            }),
            error: fn({}, l, {
              value: pr
            }),
            group: fn({}, l, {
              value: Zn
            }),
            groupCollapsed: fn({}, l, {
              value: Ue
            }),
            groupEnd: fn({}, l, {
              value: _r
            })
          });
        }
        Kn < 0 && pe("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var bn = Ae.ReactCurrentDispatcher, Dt;
    function on(l, y, S) {
      {
        if (Dt === void 0)
          try {
            throw Error();
          } catch (Z) {
            var D = Z.stack.trim().match(/\n( *(at )?)/);
            Dt = D && D[1] || "";
          }
        return `
` + Dt + l;
      }
    }
    var _n = !1, ct;
    {
      var lt = typeof WeakMap == "function" ? WeakMap : Map;
      ct = new lt();
    }
    function Jn(l, y) {
      if (!l || _n)
        return "";
      {
        var S = ct.get(l);
        if (S !== void 0)
          return S;
      }
      var D;
      _n = !0;
      var Z = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var X;
      X = bn.current, bn.current = null, xi();
      try {
        if (y) {
          var H = function() {
            throw Error();
          };
          if (Object.defineProperty(H.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(H, []);
            } catch (he) {
              D = he;
            }
            Reflect.construct(l, [], H);
          } else {
            try {
              H.call();
            } catch (he) {
              D = he;
            }
            l.call(H.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (he) {
            D = he;
          }
          l();
        }
      } catch (he) {
        if (he && D && typeof he.stack == "string") {
          for (var G = he.stack.split(`
`), me = D.stack.split(`
`), ie = G.length - 1, ae = me.length - 1; ie >= 1 && ae >= 0 && G[ie] !== me[ae]; )
            ae--;
          for (; ie >= 1 && ae >= 0; ie--, ae--)
            if (G[ie] !== me[ae]) {
              if (ie !== 1 || ae !== 1)
                do
                  if (ie--, ae--, ae < 0 || G[ie] !== me[ae]) {
                    var Ie = `
` + G[ie].replace(" at new ", " at ");
                    return l.displayName && Ie.includes("<anonymous>") && (Ie = Ie.replace("<anonymous>", l.displayName)), typeof l == "function" && ct.set(l, Ie), Ie;
                  }
                while (ie >= 1 && ae >= 0);
              break;
            }
        }
      } finally {
        _n = !1, bn.current = X, In(), Error.prepareStackTrace = Z;
      }
      var en = l ? l.displayName || l.name : "", wn = en ? on(en) : "";
      return typeof l == "function" && ct.set(l, wn), wn;
    }
    function wr(l, y, S) {
      return Jn(l, !1);
    }
    function De(l) {
      var y = l.prototype;
      return !!(y && y.isReactComponent);
    }
    function sn(l, y, S) {
      if (l == null)
        return "";
      if (typeof l == "function")
        return Jn(l, De(l));
      if (typeof l == "string")
        return on(l);
      switch (l) {
        case K:
          return on("Suspense");
        case L:
          return on("SuspenseList");
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case b:
            return wr(l.render);
          case B:
            return sn(l.type, y, S);
          case j: {
            var D = l, Z = D._payload, X = D._init;
            try {
              return sn(X(Z), y, S);
            } catch {
            }
          }
        }
      return "";
    }
    var Xn = Object.prototype.hasOwnProperty, Ge = {}, Ft = Ae.ReactDebugCurrentFrame;
    function ht(l) {
      if (l) {
        var y = l._owner, S = sn(l.type, l._source, y ? y.type : null);
        Ft.setExtraStackFrame(S);
      } else
        Ft.setExtraStackFrame(null);
    }
    function Vn(l, y, S, D, Z) {
      {
        var X = Function.call.bind(Xn);
        for (var H in l)
          if (X(l, H)) {
            var G = void 0;
            try {
              if (typeof l[H] != "function") {
                var me = Error((D || "React class") + ": " + S + " type `" + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[H] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw me.name = "Invariant Violation", me;
              }
              G = l[H](y, H, D, S, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ie) {
              G = ie;
            }
            G && !(G instanceof Error) && (ht(Z), pe("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", D || "React class", S, H, typeof G), ht(null)), G instanceof Error && !(G.message in Ge) && (Ge[G.message] = !0, ht(Z), pe("Failed %s type: %s", S, G.message), ht(null));
          }
      }
    }
    var Fe = Array.isArray;
    function vn(l) {
      return Fe(l);
    }
    function gt(l) {
      {
        var y = typeof Symbol == "function" && Symbol.toStringTag, S = y && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return S;
      }
    }
    function Ei(l) {
      try {
        return On(l), !1;
      } catch {
        return !0;
      }
    }
    function On(l) {
      return "" + l;
    }
    function mr(l) {
      if (Ei(l))
        return pe("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", gt(l)), On(l);
    }
    var Ln = Ae.ReactCurrentOwner, Pn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, dt, pt;
    function Mt(l) {
      if (Xn.call(l, "ref")) {
        var y = Object.getOwnPropertyDescriptor(l, "ref").get;
        if (y && y.isReactWarning)
          return !1;
      }
      return l.ref !== void 0;
    }
    function Wt(l) {
      if (Xn.call(l, "key")) {
        var y = Object.getOwnPropertyDescriptor(l, "key").get;
        if (y && y.isReactWarning)
          return !1;
      }
      return l.key !== void 0;
    }
    function Nt(l, y) {
      typeof l.ref == "string" && Ln.current;
    }
    function Bt(l, y) {
      {
        var S = function() {
          dt || (dt = !0, pe("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", y));
        };
        S.isReactWarning = !0, Object.defineProperty(l, "key", {
          get: S,
          configurable: !0
        });
      }
    }
    function kt(l, y) {
      {
        var S = function() {
          pt || (pt = !0, pe("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", y));
        };
        S.isReactWarning = !0, Object.defineProperty(l, "ref", {
          get: S,
          configurable: !0
        });
      }
    }
    var $t = function(l, y, S, D, Z, X, H) {
      var G = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: o,
        // Built-in properties that belong on the element
        type: l,
        key: y,
        ref: S,
        props: H,
        // Record the component responsible for creating this element.
        _owner: X
      };
      return G._store = {}, Object.defineProperty(G._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(G, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: D
      }), Object.defineProperty(G, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Z
      }), Object.freeze && (Object.freeze(G.props), Object.freeze(G)), G;
    };
    function Gt(l, y, S, D, Z) {
      {
        var X, H = {}, G = null, me = null;
        S !== void 0 && (mr(S), G = "" + S), Wt(y) && (mr(y.key), G = "" + y.key), Mt(y) && (me = y.ref, Nt(y, Z));
        for (X in y)
          Xn.call(y, X) && !Pn.hasOwnProperty(X) && (H[X] = y[X]);
        if (l && l.defaultProps) {
          var ie = l.defaultProps;
          for (X in ie)
            H[X] === void 0 && (H[X] = ie[X]);
        }
        if (G || me) {
          var ae = typeof l == "function" ? l.displayName || l.name || "Unknown" : l;
          G && Bt(H, ae), me && kt(H, ae);
        }
        return $t(l, G, me, Z, D, Ln.current, H);
      }
    }
    var zt = Ae.ReactCurrentOwner, xr = Ae.ReactDebugCurrentFrame;
    function Un(l) {
      if (l) {
        var y = l._owner, S = sn(l.type, l._source, y ? y.type : null);
        xr.setExtraStackFrame(S);
      } else
        xr.setExtraStackFrame(null);
    }
    var _t;
    _t = !1;
    function vt(l) {
      return typeof l == "object" && l !== null && l.$$typeof === o;
    }
    function Er() {
      {
        if (zt.current) {
          var l = an(zt.current.type);
          if (l)
            return `

Check the render method of \`` + l + "`.";
        }
        return "";
      }
    }
    function yi(l) {
      return "";
    }
    var yr = {};
    function Ri(l) {
      {
        var y = Er();
        if (!y) {
          var S = typeof l == "string" ? l : l.displayName || l.name;
          S && (y = `

Check the top-level render call using <` + S + ">.");
        }
        return y;
      }
    }
    function Ht(l, y) {
      {
        if (!l._store || l._store.validated || l.key != null)
          return;
        l._store.validated = !0;
        var S = Ri(y);
        if (yr[S])
          return;
        yr[S] = !0;
        var D = "";
        l && l._owner && l._owner !== zt.current && (D = " It was passed a child from " + an(l._owner.type) + "."), Un(l), pe('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', S, D), Un(null);
      }
    }
    function Rr(l, y) {
      {
        if (typeof l != "object")
          return;
        if (vn(l))
          for (var S = 0; S < l.length; S++) {
            var D = l[S];
            vt(D) && Ht(D, y);
          }
        else if (vt(l))
          l._store && (l._store.validated = !0);
        else if (l) {
          var Z = we(l);
          if (typeof Z == "function" && Z !== l.entries)
            for (var X = Z.call(l), H; !(H = X.next()).done; )
              vt(H.value) && Ht(H.value, y);
        }
      }
    }
    function Ai(l) {
      {
        var y = l.type;
        if (y == null || typeof y == "string")
          return;
        var S;
        if (typeof y == "function")
          S = y.propTypes;
        else if (typeof y == "object" && (y.$$typeof === b || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        y.$$typeof === B))
          S = y.propTypes;
        else
          return;
        if (S) {
          var D = an(y);
          Vn(S, l.props, "prop", D, l);
        } else if (y.PropTypes !== void 0 && !_t) {
          _t = !0;
          var Z = an(y);
          pe("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Z || "Unknown");
        }
        typeof y.getDefaultProps == "function" && !y.getDefaultProps.isReactClassApproved && pe("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Si(l) {
      {
        for (var y = Object.keys(l.props), S = 0; S < y.length; S++) {
          var D = y[S];
          if (D !== "children" && D !== "key") {
            Un(l), pe("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", D), Un(null);
            break;
          }
        }
        l.ref !== null && (Un(l), pe("Invalid attribute `ref` supplied to `React.Fragment`."), Un(null));
      }
    }
    var wt = {};
    function Ar(l, y, S, D, Z, X) {
      {
        var H = wi(l);
        if (!H) {
          var G = "";
          (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (G += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var me = yi();
          me ? G += me : G += Er();
          var ie;
          l === null ? ie = "null" : vn(l) ? ie = "array" : l !== void 0 && l.$$typeof === o ? (ie = "<" + (an(l.type) || "Unknown") + " />", G = " Did you accidentally export a JSX literal instead of a component?") : ie = typeof l, pe("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ie, G);
        }
        var ae = Gt(l, y, S, Z, X);
        if (ae == null)
          return ae;
        if (H) {
          var Ie = y.children;
          if (Ie !== void 0)
            if (D)
              if (vn(Ie)) {
                for (var en = 0; en < Ie.length; en++)
                  Rr(Ie[en], l);
                Object.freeze && Object.freeze(Ie);
              } else
                pe("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Rr(Ie, l);
        }
        if (Xn.call(y, "key")) {
          var wn = an(l), he = Object.keys(y).filter(function(Oi) {
            return Oi !== "key";
          }), Kt = he.length > 0 ? "{key: someKey, " + he.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wt[wn + Kt]) {
            var bi = he.length > 0 ? "{" + he.join(": ..., ") + ": ...}" : "{}";
            pe(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Kt, wn, bi, wn), wt[wn + Kt] = !0;
          }
        }
        return l === _ ? Si(ae) : Ai(ae), ae;
      }
    }
    function Yt(l, y, S) {
      return Ar(l, y, S, !0);
    }
    function Ti(l, y, S) {
      return Ar(l, y, S, !1);
    }
    var Ci = Ti, Ii = Yt;
    sr.Fragment = _, sr.jsx = Ci, sr.jsxs = Ii;
  }()), sr;
}
var No;
function q_() {
  return No || (No = 1, process.env.NODE_ENV === "production" ? gi.exports = Y_() : gi.exports = K_()), gi.exports;
}
var Ku = q_();
const Jo = n_(void 0);
function Z_() {
  return t_(Jo);
}
const sv = ({ children: c, configuration: o }) => {
  const i = Ko(), _ = Ut.getInstance(o), w = ft(H_), R = ft(z_), T = ft(Zo), F = ft($_), b = ft(k_), K = async (ve) => {
    const we = await d_.generate();
    return _.startOidcSignIn(ve, we);
  }, L = (ve) => {
    _.signOut(ve);
  }, B = () => _.getConfigurationEndpoints(), j = () => _.getBaseUrl(), oe = () => _.getSavedLocation(), se = () => {
    B().then((ve) => {
      i(
        di({
          clientId: o.clientId,
          tokenEndpoint: ve.tokenEndpoint,
          baseUrl: o.baseUrl
        })
      );
    });
  };
  return pi(() => {
    if (T) {
      if (b)
        return;
      const ve = _.getAccessToken();
      if (!s_(ve))
        i(B_()), se();
      else {
        const we = h_(ve), Ae = setInterval(() => {
          se();
        }, we);
        return () => {
          clearInterval(Ae);
        };
      }
    }
  }, [T, F]), pi(() => {
    b || (w && L(window.location.href), R && R.name === dn.SessionExpired && se());
  }, [w, R]), /* @__PURE__ */ Ku.jsx(
    Jo.Provider,
    {
      value: {
        configuration: o,
        signIn: K,
        signOut: L,
        getConfigurationEndpoints: B,
        getBaseUrl: j,
        getSavedRedirectUrl: oe,
        getNewRefreshToken: se
      },
      children: c
    }
  );
};
var lr = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var J_ = lr.exports, Bo;
function X_() {
  return Bo || (Bo = 1, function(c, o) {
    (function() {
      var i, _ = "4.17.21", w = 200, R = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", T = "Expected a function", F = "Invalid `variable` option passed into `_.template`", b = "__lodash_hash_undefined__", K = 500, L = "__lodash_placeholder__", B = 1, j = 2, oe = 4, se = 1, ve = 2, we = 1, Ae = 2, pe = 4, Ve = 8, zn = 16, Qe = 32, Hn = 64, je = 128, Yn = 256, st = 512, wi = 30, mi = "...", gr = 800, an = 16, fn = 1, Kn = 2, dr = 3, qn = 1 / 0, pn = 9007199254740991, pr = 17976931348623157e292, Zn = NaN, Ue = 4294967295, _r = Ue - 1, vr = Ue >>> 1, xi = [
        ["ary", je],
        ["bind", we],
        ["bindKey", Ae],
        ["curry", Ve],
        ["curryRight", zn],
        ["flip", st],
        ["partial", Qe],
        ["partialRight", Hn],
        ["rearg", Yn]
      ], In = "[object Arguments]", bn = "[object Array]", Dt = "[object AsyncFunction]", on = "[object Boolean]", _n = "[object Date]", ct = "[object DOMException]", lt = "[object Error]", Jn = "[object Function]", wr = "[object GeneratorFunction]", De = "[object Map]", sn = "[object Number]", Xn = "[object Null]", Ge = "[object Object]", Ft = "[object Promise]", ht = "[object Proxy]", Vn = "[object RegExp]", Fe = "[object Set]", vn = "[object String]", gt = "[object Symbol]", Ei = "[object Undefined]", On = "[object WeakMap]", mr = "[object WeakSet]", Ln = "[object ArrayBuffer]", Pn = "[object DataView]", dt = "[object Float32Array]", pt = "[object Float64Array]", Mt = "[object Int8Array]", Wt = "[object Int16Array]", Nt = "[object Int32Array]", Bt = "[object Uint8Array]", kt = "[object Uint8ClampedArray]", $t = "[object Uint16Array]", Gt = "[object Uint32Array]", zt = /\b__p \+= '';/g, xr = /\b(__p \+=) '' \+/g, Un = /(__e\(.*?\)|\b__t\)) \+\n'';/g, _t = /&(?:amp|lt|gt|quot|#39);/g, vt = /[&<>"']/g, Er = RegExp(_t.source), yi = RegExp(vt.source), yr = /<%-([\s\S]+?)%>/g, Ri = /<%([\s\S]+?)%>/g, Ht = /<%=([\s\S]+?)%>/g, Rr = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ai = /^\w*$/, Si = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, wt = /[\\^$.*+?()[\]{}|]/g, Ar = RegExp(wt.source), Yt = /^\s+/, Ti = /\s/, Ci = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ii = /\{\n\/\* \[wrapped with (.+)\] \*/, l = /,? & /, y = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, S = /[()=,{}\[\]\/\s]/, D = /\\(\\)?/g, Z = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, X = /\w*$/, H = /^[-+]0x[0-9a-f]+$/i, G = /^0b[01]+$/i, me = /^\[object .+?Constructor\]$/, ie = /^0o[0-7]+$/i, ae = /^(?:0|[1-9]\d*)$/, Ie = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, en = /($^)/, wn = /['\n\r\u2028\u2029\\]/g, he = "\\ud800-\\udfff", Kt = "\\u0300-\\u036f", bi = "\\ufe20-\\ufe2f", Oi = "\\u20d0-\\u20ff", Qu = Kt + bi + Oi, ju = "\\u2700-\\u27bf", ea = "a-z\\xdf-\\xf6\\xf8-\\xff", Xo = "\\xac\\xb1\\xd7\\xf7", Vo = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Qo = "\\u2000-\\u206f", jo = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", na = "A-Z\\xc0-\\xd6\\xd8-\\xde", ta = "\\ufe0e\\ufe0f", ra = Xo + Vo + Qo + jo, Li = "['’]", es = "[" + he + "]", ia = "[" + ra + "]", Sr = "[" + Qu + "]", ua = "\\d+", ns = "[" + ju + "]", aa = "[" + ea + "]", fa = "[^" + he + ra + ua + ju + ea + na + "]", Pi = "\\ud83c[\\udffb-\\udfff]", ts = "(?:" + Sr + "|" + Pi + ")", oa = "[^" + he + "]", Ui = "(?:\\ud83c[\\udde6-\\uddff]){2}", Di = "[\\ud800-\\udbff][\\udc00-\\udfff]", mt = "[" + na + "]", sa = "\\u200d", ca = "(?:" + aa + "|" + fa + ")", rs = "(?:" + mt + "|" + fa + ")", la = "(?:" + Li + "(?:d|ll|m|re|s|t|ve))?", ha = "(?:" + Li + "(?:D|LL|M|RE|S|T|VE))?", ga = ts + "?", da = "[" + ta + "]?", is = "(?:" + sa + "(?:" + [oa, Ui, Di].join("|") + ")" + da + ga + ")*", us = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", as = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", pa = da + ga + is, fs = "(?:" + [ns, Ui, Di].join("|") + ")" + pa, os = "(?:" + [oa + Sr + "?", Sr, Ui, Di, es].join("|") + ")", ss = RegExp(Li, "g"), cs = RegExp(Sr, "g"), Fi = RegExp(Pi + "(?=" + Pi + ")|" + os + pa, "g"), ls = RegExp([
        mt + "?" + aa + "+" + la + "(?=" + [ia, mt, "$"].join("|") + ")",
        rs + "+" + ha + "(?=" + [ia, mt + ca, "$"].join("|") + ")",
        mt + "?" + ca + "+" + la,
        mt + "+" + ha,
        as,
        us,
        ua,
        fs
      ].join("|"), "g"), hs = RegExp("[" + sa + he + Qu + ta + "]"), gs = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, ds = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], ps = -1, te = {};
      te[dt] = te[pt] = te[Mt] = te[Wt] = te[Nt] = te[Bt] = te[kt] = te[$t] = te[Gt] = !0, te[In] = te[bn] = te[Ln] = te[on] = te[Pn] = te[_n] = te[lt] = te[Jn] = te[De] = te[sn] = te[Ge] = te[Vn] = te[Fe] = te[vn] = te[On] = !1;
      var ne = {};
      ne[In] = ne[bn] = ne[Ln] = ne[Pn] = ne[on] = ne[_n] = ne[dt] = ne[pt] = ne[Mt] = ne[Wt] = ne[Nt] = ne[De] = ne[sn] = ne[Ge] = ne[Vn] = ne[Fe] = ne[vn] = ne[gt] = ne[Bt] = ne[kt] = ne[$t] = ne[Gt] = !0, ne[lt] = ne[Jn] = ne[On] = !1;
      var _s = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, vs = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, ws = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, ms = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, xs = parseFloat, Es = parseInt, _a = typeof li == "object" && li && li.Object === Object && li, ys = typeof self == "object" && self && self.Object === Object && self, xe = _a || ys || Function("return this")(), Mi = o && !o.nodeType && o, Qn = Mi && !0 && c && !c.nodeType && c, va = Qn && Qn.exports === Mi, Wi = va && _a.process, ze = function() {
        try {
          var g = Qn && Qn.require && Qn.require("util").types;
          return g || Wi && Wi.binding && Wi.binding("util");
        } catch {
        }
      }(), wa = ze && ze.isArrayBuffer, ma = ze && ze.isDate, xa = ze && ze.isMap, Ea = ze && ze.isRegExp, ya = ze && ze.isSet, Ra = ze && ze.isTypedArray;
      function Me(g, v, p) {
        switch (p.length) {
          case 0:
            return g.call(v);
          case 1:
            return g.call(v, p[0]);
          case 2:
            return g.call(v, p[0], p[1]);
          case 3:
            return g.call(v, p[0], p[1], p[2]);
        }
        return g.apply(v, p);
      }
      function Rs(g, v, p, C) {
        for (var M = -1, J = g == null ? 0 : g.length; ++M < J; ) {
          var ge = g[M];
          v(C, ge, p(ge), g);
        }
        return C;
      }
      function He(g, v) {
        for (var p = -1, C = g == null ? 0 : g.length; ++p < C && v(g[p], p, g) !== !1; )
          ;
        return g;
      }
      function As(g, v) {
        for (var p = g == null ? 0 : g.length; p-- && v(g[p], p, g) !== !1; )
          ;
        return g;
      }
      function Aa(g, v) {
        for (var p = -1, C = g == null ? 0 : g.length; ++p < C; )
          if (!v(g[p], p, g))
            return !1;
        return !0;
      }
      function Dn(g, v) {
        for (var p = -1, C = g == null ? 0 : g.length, M = 0, J = []; ++p < C; ) {
          var ge = g[p];
          v(ge, p, g) && (J[M++] = ge);
        }
        return J;
      }
      function Tr(g, v) {
        var p = g == null ? 0 : g.length;
        return !!p && xt(g, v, 0) > -1;
      }
      function Ni(g, v, p) {
        for (var C = -1, M = g == null ? 0 : g.length; ++C < M; )
          if (p(v, g[C]))
            return !0;
        return !1;
      }
      function re(g, v) {
        for (var p = -1, C = g == null ? 0 : g.length, M = Array(C); ++p < C; )
          M[p] = v(g[p], p, g);
        return M;
      }
      function Fn(g, v) {
        for (var p = -1, C = v.length, M = g.length; ++p < C; )
          g[M + p] = v[p];
        return g;
      }
      function Bi(g, v, p, C) {
        var M = -1, J = g == null ? 0 : g.length;
        for (C && J && (p = g[++M]); ++M < J; )
          p = v(p, g[M], M, g);
        return p;
      }
      function Ss(g, v, p, C) {
        var M = g == null ? 0 : g.length;
        for (C && M && (p = g[--M]); M--; )
          p = v(p, g[M], M, g);
        return p;
      }
      function ki(g, v) {
        for (var p = -1, C = g == null ? 0 : g.length; ++p < C; )
          if (v(g[p], p, g))
            return !0;
        return !1;
      }
      var Ts = $i("length");
      function Cs(g) {
        return g.split("");
      }
      function Is(g) {
        return g.match(y) || [];
      }
      function Sa(g, v, p) {
        var C;
        return p(g, function(M, J, ge) {
          if (v(M, J, ge))
            return C = J, !1;
        }), C;
      }
      function Cr(g, v, p, C) {
        for (var M = g.length, J = p + (C ? 1 : -1); C ? J-- : ++J < M; )
          if (v(g[J], J, g))
            return J;
        return -1;
      }
      function xt(g, v, p) {
        return v === v ? ks(g, v, p) : Cr(g, Ta, p);
      }
      function bs(g, v, p, C) {
        for (var M = p - 1, J = g.length; ++M < J; )
          if (C(g[M], v))
            return M;
        return -1;
      }
      function Ta(g) {
        return g !== g;
      }
      function Ca(g, v) {
        var p = g == null ? 0 : g.length;
        return p ? zi(g, v) / p : Zn;
      }
      function $i(g) {
        return function(v) {
          return v == null ? i : v[g];
        };
      }
      function Gi(g) {
        return function(v) {
          return g == null ? i : g[v];
        };
      }
      function Ia(g, v, p, C, M) {
        return M(g, function(J, ge, ee) {
          p = C ? (C = !1, J) : v(p, J, ge, ee);
        }), p;
      }
      function Os(g, v) {
        var p = g.length;
        for (g.sort(v); p--; )
          g[p] = g[p].value;
        return g;
      }
      function zi(g, v) {
        for (var p, C = -1, M = g.length; ++C < M; ) {
          var J = v(g[C]);
          J !== i && (p = p === i ? J : p + J);
        }
        return p;
      }
      function Hi(g, v) {
        for (var p = -1, C = Array(g); ++p < g; )
          C[p] = v(p);
        return C;
      }
      function Ls(g, v) {
        return re(v, function(p) {
          return [p, g[p]];
        });
      }
      function ba(g) {
        return g && g.slice(0, Ua(g) + 1).replace(Yt, "");
      }
      function We(g) {
        return function(v) {
          return g(v);
        };
      }
      function Yi(g, v) {
        return re(v, function(p) {
          return g[p];
        });
      }
      function qt(g, v) {
        return g.has(v);
      }
      function Oa(g, v) {
        for (var p = -1, C = g.length; ++p < C && xt(v, g[p], 0) > -1; )
          ;
        return p;
      }
      function La(g, v) {
        for (var p = g.length; p-- && xt(v, g[p], 0) > -1; )
          ;
        return p;
      }
      function Ps(g, v) {
        for (var p = g.length, C = 0; p--; )
          g[p] === v && ++C;
        return C;
      }
      var Us = Gi(_s), Ds = Gi(vs);
      function Fs(g) {
        return "\\" + ms[g];
      }
      function Ms(g, v) {
        return g == null ? i : g[v];
      }
      function Et(g) {
        return hs.test(g);
      }
      function Ws(g) {
        return gs.test(g);
      }
      function Ns(g) {
        for (var v, p = []; !(v = g.next()).done; )
          p.push(v.value);
        return p;
      }
      function Ki(g) {
        var v = -1, p = Array(g.size);
        return g.forEach(function(C, M) {
          p[++v] = [M, C];
        }), p;
      }
      function Pa(g, v) {
        return function(p) {
          return g(v(p));
        };
      }
      function Mn(g, v) {
        for (var p = -1, C = g.length, M = 0, J = []; ++p < C; ) {
          var ge = g[p];
          (ge === v || ge === L) && (g[p] = L, J[M++] = p);
        }
        return J;
      }
      function Ir(g) {
        var v = -1, p = Array(g.size);
        return g.forEach(function(C) {
          p[++v] = C;
        }), p;
      }
      function Bs(g) {
        var v = -1, p = Array(g.size);
        return g.forEach(function(C) {
          p[++v] = [C, C];
        }), p;
      }
      function ks(g, v, p) {
        for (var C = p - 1, M = g.length; ++C < M; )
          if (g[C] === v)
            return C;
        return -1;
      }
      function $s(g, v, p) {
        for (var C = p + 1; C--; )
          if (g[C] === v)
            return C;
        return C;
      }
      function yt(g) {
        return Et(g) ? zs(g) : Ts(g);
      }
      function nn(g) {
        return Et(g) ? Hs(g) : Cs(g);
      }
      function Ua(g) {
        for (var v = g.length; v-- && Ti.test(g.charAt(v)); )
          ;
        return v;
      }
      var Gs = Gi(ws);
      function zs(g) {
        for (var v = Fi.lastIndex = 0; Fi.test(g); )
          ++v;
        return v;
      }
      function Hs(g) {
        return g.match(Fi) || [];
      }
      function Ys(g) {
        return g.match(ls) || [];
      }
      var Ks = function g(v) {
        v = v == null ? xe : Rt.defaults(xe.Object(), v, Rt.pick(xe, ds));
        var p = v.Array, C = v.Date, M = v.Error, J = v.Function, ge = v.Math, ee = v.Object, qi = v.RegExp, qs = v.String, Ye = v.TypeError, br = p.prototype, Zs = J.prototype, At = ee.prototype, Or = v["__core-js_shared__"], Lr = Zs.toString, Q = At.hasOwnProperty, Js = 0, Da = function() {
          var e = /[^.]+$/.exec(Or && Or.keys && Or.keys.IE_PROTO || "");
          return e ? "Symbol(src)_1." + e : "";
        }(), Pr = At.toString, Xs = Lr.call(ee), Vs = xe._, Qs = qi(
          "^" + Lr.call(Q).replace(wt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Ur = va ? v.Buffer : i, Wn = v.Symbol, Dr = v.Uint8Array, Fa = Ur ? Ur.allocUnsafe : i, Fr = Pa(ee.getPrototypeOf, ee), Ma = ee.create, Wa = At.propertyIsEnumerable, Mr = br.splice, Na = Wn ? Wn.isConcatSpreadable : i, Zt = Wn ? Wn.iterator : i, jn = Wn ? Wn.toStringTag : i, Wr = function() {
          try {
            var e = it(ee, "defineProperty");
            return e({}, "", {}), e;
          } catch {
          }
        }(), js = v.clearTimeout !== xe.clearTimeout && v.clearTimeout, ec = C && C.now !== xe.Date.now && C.now, nc = v.setTimeout !== xe.setTimeout && v.setTimeout, Nr = ge.ceil, Br = ge.floor, Zi = ee.getOwnPropertySymbols, tc = Ur ? Ur.isBuffer : i, Ba = v.isFinite, rc = br.join, ic = Pa(ee.keys, ee), de = ge.max, ye = ge.min, uc = C.now, ac = v.parseInt, ka = ge.random, fc = br.reverse, Ji = it(v, "DataView"), Jt = it(v, "Map"), Xi = it(v, "Promise"), St = it(v, "Set"), Xt = it(v, "WeakMap"), Vt = it(ee, "create"), kr = Xt && new Xt(), Tt = {}, oc = ut(Ji), sc = ut(Jt), cc = ut(Xi), lc = ut(St), hc = ut(Xt), $r = Wn ? Wn.prototype : i, Qt = $r ? $r.valueOf : i, $a = $r ? $r.toString : i;
        function a(e) {
          if (fe(e) && !W(e) && !(e instanceof Y)) {
            if (e instanceof Ke)
              return e;
            if (Q.call(e, "__wrapped__"))
              return zf(e);
          }
          return new Ke(e);
        }
        var Ct = /* @__PURE__ */ function() {
          function e() {
          }
          return function(n) {
            if (!ue(n))
              return {};
            if (Ma)
              return Ma(n);
            e.prototype = n;
            var t = new e();
            return e.prototype = i, t;
          };
        }();
        function Gr() {
        }
        function Ke(e, n) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = i;
        }
        a.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: yr,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Ri,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Ht,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: a
          }
        }, a.prototype = Gr.prototype, a.prototype.constructor = a, Ke.prototype = Ct(Gr.prototype), Ke.prototype.constructor = Ke;
        function Y(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Ue, this.__views__ = [];
        }
        function gc() {
          var e = new Y(this.__wrapped__);
          return e.__actions__ = be(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = be(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = be(this.__views__), e;
        }
        function dc() {
          if (this.__filtered__) {
            var e = new Y(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else
            e = this.clone(), e.__dir__ *= -1;
          return e;
        }
        function pc() {
          var e = this.__wrapped__.value(), n = this.__dir__, t = W(e), r = n < 0, u = t ? e.length : 0, f = Cl(0, u, this.__views__), s = f.start, h = f.end, d = h - s, m = r ? h : s - 1, x = this.__iteratees__, E = x.length, A = 0, I = ye(d, this.__takeCount__);
          if (!t || !r && u == d && I == d)
            return hf(e, this.__actions__);
          var P = [];
          e:
            for (; d-- && A < I; ) {
              m += n;
              for (var k = -1, U = e[m]; ++k < E; ) {
                var z = x[k], q = z.iteratee, ke = z.type, Ce = q(U);
                if (ke == Kn)
                  U = Ce;
                else if (!Ce) {
                  if (ke == fn)
                    continue e;
                  break e;
                }
              }
              P[A++] = U;
            }
          return P;
        }
        Y.prototype = Ct(Gr.prototype), Y.prototype.constructor = Y;
        function et(e) {
          var n = -1, t = e == null ? 0 : e.length;
          for (this.clear(); ++n < t; ) {
            var r = e[n];
            this.set(r[0], r[1]);
          }
        }
        function _c() {
          this.__data__ = Vt ? Vt(null) : {}, this.size = 0;
        }
        function vc(e) {
          var n = this.has(e) && delete this.__data__[e];
          return this.size -= n ? 1 : 0, n;
        }
        function wc(e) {
          var n = this.__data__;
          if (Vt) {
            var t = n[e];
            return t === b ? i : t;
          }
          return Q.call(n, e) ? n[e] : i;
        }
        function mc(e) {
          var n = this.__data__;
          return Vt ? n[e] !== i : Q.call(n, e);
        }
        function xc(e, n) {
          var t = this.__data__;
          return this.size += this.has(e) ? 0 : 1, t[e] = Vt && n === i ? b : n, this;
        }
        et.prototype.clear = _c, et.prototype.delete = vc, et.prototype.get = wc, et.prototype.has = mc, et.prototype.set = xc;
        function mn(e) {
          var n = -1, t = e == null ? 0 : e.length;
          for (this.clear(); ++n < t; ) {
            var r = e[n];
            this.set(r[0], r[1]);
          }
        }
        function Ec() {
          this.__data__ = [], this.size = 0;
        }
        function yc(e) {
          var n = this.__data__, t = zr(n, e);
          if (t < 0)
            return !1;
          var r = n.length - 1;
          return t == r ? n.pop() : Mr.call(n, t, 1), --this.size, !0;
        }
        function Rc(e) {
          var n = this.__data__, t = zr(n, e);
          return t < 0 ? i : n[t][1];
        }
        function Ac(e) {
          return zr(this.__data__, e) > -1;
        }
        function Sc(e, n) {
          var t = this.__data__, r = zr(t, e);
          return r < 0 ? (++this.size, t.push([e, n])) : t[r][1] = n, this;
        }
        mn.prototype.clear = Ec, mn.prototype.delete = yc, mn.prototype.get = Rc, mn.prototype.has = Ac, mn.prototype.set = Sc;
        function xn(e) {
          var n = -1, t = e == null ? 0 : e.length;
          for (this.clear(); ++n < t; ) {
            var r = e[n];
            this.set(r[0], r[1]);
          }
        }
        function Tc() {
          this.size = 0, this.__data__ = {
            hash: new et(),
            map: new (Jt || mn)(),
            string: new et()
          };
        }
        function Cc(e) {
          var n = ni(this, e).delete(e);
          return this.size -= n ? 1 : 0, n;
        }
        function Ic(e) {
          return ni(this, e).get(e);
        }
        function bc(e) {
          return ni(this, e).has(e);
        }
        function Oc(e, n) {
          var t = ni(this, e), r = t.size;
          return t.set(e, n), this.size += t.size == r ? 0 : 1, this;
        }
        xn.prototype.clear = Tc, xn.prototype.delete = Cc, xn.prototype.get = Ic, xn.prototype.has = bc, xn.prototype.set = Oc;
        function nt(e) {
          var n = -1, t = e == null ? 0 : e.length;
          for (this.__data__ = new xn(); ++n < t; )
            this.add(e[n]);
        }
        function Lc(e) {
          return this.__data__.set(e, b), this;
        }
        function Pc(e) {
          return this.__data__.has(e);
        }
        nt.prototype.add = nt.prototype.push = Lc, nt.prototype.has = Pc;
        function tn(e) {
          var n = this.__data__ = new mn(e);
          this.size = n.size;
        }
        function Uc() {
          this.__data__ = new mn(), this.size = 0;
        }
        function Dc(e) {
          var n = this.__data__, t = n.delete(e);
          return this.size = n.size, t;
        }
        function Fc(e) {
          return this.__data__.get(e);
        }
        function Mc(e) {
          return this.__data__.has(e);
        }
        function Wc(e, n) {
          var t = this.__data__;
          if (t instanceof mn) {
            var r = t.__data__;
            if (!Jt || r.length < w - 1)
              return r.push([e, n]), this.size = ++t.size, this;
            t = this.__data__ = new xn(r);
          }
          return t.set(e, n), this.size = t.size, this;
        }
        tn.prototype.clear = Uc, tn.prototype.delete = Dc, tn.prototype.get = Fc, tn.prototype.has = Mc, tn.prototype.set = Wc;
        function Ga(e, n) {
          var t = W(e), r = !t && at(e), u = !t && !r && Gn(e), f = !t && !r && !u && Lt(e), s = t || r || u || f, h = s ? Hi(e.length, qs) : [], d = h.length;
          for (var m in e)
            (n || Q.call(e, m)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
            (m == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            u && (m == "offset" || m == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            f && (m == "buffer" || m == "byteLength" || m == "byteOffset") || // Skip index properties.
            An(m, d))) && h.push(m);
          return h;
        }
        function za(e) {
          var n = e.length;
          return n ? e[fu(0, n - 1)] : i;
        }
        function Nc(e, n) {
          return ti(be(e), tt(n, 0, e.length));
        }
        function Bc(e) {
          return ti(be(e));
        }
        function Vi(e, n, t) {
          (t !== i && !rn(e[n], t) || t === i && !(n in e)) && En(e, n, t);
        }
        function jt(e, n, t) {
          var r = e[n];
          (!(Q.call(e, n) && rn(r, t)) || t === i && !(n in e)) && En(e, n, t);
        }
        function zr(e, n) {
          for (var t = e.length; t--; )
            if (rn(e[t][0], n))
              return t;
          return -1;
        }
        function kc(e, n, t, r) {
          return Nn(e, function(u, f, s) {
            n(r, u, t(u), s);
          }), r;
        }
        function Ha(e, n) {
          return e && ln(n, _e(n), e);
        }
        function $c(e, n) {
          return e && ln(n, Le(n), e);
        }
        function En(e, n, t) {
          n == "__proto__" && Wr ? Wr(e, n, {
            configurable: !0,
            enumerable: !0,
            value: t,
            writable: !0
          }) : e[n] = t;
        }
        function Qi(e, n) {
          for (var t = -1, r = n.length, u = p(r), f = e == null; ++t < r; )
            u[t] = f ? i : Pu(e, n[t]);
          return u;
        }
        function tt(e, n, t) {
          return e === e && (t !== i && (e = e <= t ? e : t), n !== i && (e = e >= n ? e : n)), e;
        }
        function qe(e, n, t, r, u, f) {
          var s, h = n & B, d = n & j, m = n & oe;
          if (t && (s = u ? t(e, r, u, f) : t(e)), s !== i)
            return s;
          if (!ue(e))
            return e;
          var x = W(e);
          if (x) {
            if (s = bl(e), !h)
              return be(e, s);
          } else {
            var E = Re(e), A = E == Jn || E == wr;
            if (Gn(e))
              return pf(e, h);
            if (E == Ge || E == In || A && !u) {
              if (s = d || A ? {} : Df(e), !h)
                return d ? wl(e, $c(s, e)) : vl(e, Ha(s, e));
            } else {
              if (!ne[E])
                return u ? e : {};
              s = Ol(e, E, h);
            }
          }
          f || (f = new tn());
          var I = f.get(e);
          if (I)
            return I;
          f.set(e, s), so(e) ? e.forEach(function(U) {
            s.add(qe(U, n, t, U, e, f));
          }) : fo(e) && e.forEach(function(U, z) {
            s.set(z, qe(U, n, t, z, e, f));
          });
          var P = m ? d ? wu : vu : d ? Le : _e, k = x ? i : P(e);
          return He(k || e, function(U, z) {
            k && (z = U, U = e[z]), jt(s, z, qe(U, n, t, z, e, f));
          }), s;
        }
        function Gc(e) {
          var n = _e(e);
          return function(t) {
            return Ya(t, e, n);
          };
        }
        function Ya(e, n, t) {
          var r = t.length;
          if (e == null)
            return !r;
          for (e = ee(e); r--; ) {
            var u = t[r], f = n[u], s = e[u];
            if (s === i && !(u in e) || !f(s))
              return !1;
          }
          return !0;
        }
        function Ka(e, n, t) {
          if (typeof e != "function")
            throw new Ye(T);
          return ar(function() {
            e.apply(i, t);
          }, n);
        }
        function er(e, n, t, r) {
          var u = -1, f = Tr, s = !0, h = e.length, d = [], m = n.length;
          if (!h)
            return d;
          t && (n = re(n, We(t))), r ? (f = Ni, s = !1) : n.length >= w && (f = qt, s = !1, n = new nt(n));
          e:
            for (; ++u < h; ) {
              var x = e[u], E = t == null ? x : t(x);
              if (x = r || x !== 0 ? x : 0, s && E === E) {
                for (var A = m; A--; )
                  if (n[A] === E)
                    continue e;
                d.push(x);
              } else f(n, E, r) || d.push(x);
            }
          return d;
        }
        var Nn = xf(cn), qa = xf(eu, !0);
        function zc(e, n) {
          var t = !0;
          return Nn(e, function(r, u, f) {
            return t = !!n(r, u, f), t;
          }), t;
        }
        function Hr(e, n, t) {
          for (var r = -1, u = e.length; ++r < u; ) {
            var f = e[r], s = n(f);
            if (s != null && (h === i ? s === s && !Be(s) : t(s, h)))
              var h = s, d = f;
          }
          return d;
        }
        function Hc(e, n, t, r) {
          var u = e.length;
          for (t = N(t), t < 0 && (t = -t > u ? 0 : u + t), r = r === i || r > u ? u : N(r), r < 0 && (r += u), r = t > r ? 0 : lo(r); t < r; )
            e[t++] = n;
          return e;
        }
        function Za(e, n) {
          var t = [];
          return Nn(e, function(r, u, f) {
            n(r, u, f) && t.push(r);
          }), t;
        }
        function Ee(e, n, t, r, u) {
          var f = -1, s = e.length;
          for (t || (t = Pl), u || (u = []); ++f < s; ) {
            var h = e[f];
            n > 0 && t(h) ? n > 1 ? Ee(h, n - 1, t, r, u) : Fn(u, h) : r || (u[u.length] = h);
          }
          return u;
        }
        var ji = Ef(), Ja = Ef(!0);
        function cn(e, n) {
          return e && ji(e, n, _e);
        }
        function eu(e, n) {
          return e && Ja(e, n, _e);
        }
        function Yr(e, n) {
          return Dn(n, function(t) {
            return Sn(e[t]);
          });
        }
        function rt(e, n) {
          n = kn(n, e);
          for (var t = 0, r = n.length; e != null && t < r; )
            e = e[hn(n[t++])];
          return t && t == r ? e : i;
        }
        function Xa(e, n, t) {
          var r = n(e);
          return W(e) ? r : Fn(r, t(e));
        }
        function Se(e) {
          return e == null ? e === i ? Ei : Xn : jn && jn in ee(e) ? Tl(e) : Bl(e);
        }
        function nu(e, n) {
          return e > n;
        }
        function Yc(e, n) {
          return e != null && Q.call(e, n);
        }
        function Kc(e, n) {
          return e != null && n in ee(e);
        }
        function qc(e, n, t) {
          return e >= ye(n, t) && e < de(n, t);
        }
        function tu(e, n, t) {
          for (var r = t ? Ni : Tr, u = e[0].length, f = e.length, s = f, h = p(f), d = 1 / 0, m = []; s--; ) {
            var x = e[s];
            s && n && (x = re(x, We(n))), d = ye(x.length, d), h[s] = !t && (n || u >= 120 && x.length >= 120) ? new nt(s && x) : i;
          }
          x = e[0];
          var E = -1, A = h[0];
          e:
            for (; ++E < u && m.length < d; ) {
              var I = x[E], P = n ? n(I) : I;
              if (I = t || I !== 0 ? I : 0, !(A ? qt(A, P) : r(m, P, t))) {
                for (s = f; --s; ) {
                  var k = h[s];
                  if (!(k ? qt(k, P) : r(e[s], P, t)))
                    continue e;
                }
                A && A.push(P), m.push(I);
              }
            }
          return m;
        }
        function Zc(e, n, t, r) {
          return cn(e, function(u, f, s) {
            n(r, t(u), f, s);
          }), r;
        }
        function nr(e, n, t) {
          n = kn(n, e), e = Nf(e, n);
          var r = e == null ? e : e[hn(Je(n))];
          return r == null ? i : Me(r, e, t);
        }
        function Va(e) {
          return fe(e) && Se(e) == In;
        }
        function Jc(e) {
          return fe(e) && Se(e) == Ln;
        }
        function Xc(e) {
          return fe(e) && Se(e) == _n;
        }
        function tr(e, n, t, r, u) {
          return e === n ? !0 : e == null || n == null || !fe(e) && !fe(n) ? e !== e && n !== n : Vc(e, n, t, r, tr, u);
        }
        function Vc(e, n, t, r, u, f) {
          var s = W(e), h = W(n), d = s ? bn : Re(e), m = h ? bn : Re(n);
          d = d == In ? Ge : d, m = m == In ? Ge : m;
          var x = d == Ge, E = m == Ge, A = d == m;
          if (A && Gn(e)) {
            if (!Gn(n))
              return !1;
            s = !0, x = !1;
          }
          if (A && !x)
            return f || (f = new tn()), s || Lt(e) ? Lf(e, n, t, r, u, f) : Al(e, n, d, t, r, u, f);
          if (!(t & se)) {
            var I = x && Q.call(e, "__wrapped__"), P = E && Q.call(n, "__wrapped__");
            if (I || P) {
              var k = I ? e.value() : e, U = P ? n.value() : n;
              return f || (f = new tn()), u(k, U, t, r, f);
            }
          }
          return A ? (f || (f = new tn()), Sl(e, n, t, r, u, f)) : !1;
        }
        function Qc(e) {
          return fe(e) && Re(e) == De;
        }
        function ru(e, n, t, r) {
          var u = t.length, f = u, s = !r;
          if (e == null)
            return !f;
          for (e = ee(e); u--; ) {
            var h = t[u];
            if (s && h[2] ? h[1] !== e[h[0]] : !(h[0] in e))
              return !1;
          }
          for (; ++u < f; ) {
            h = t[u];
            var d = h[0], m = e[d], x = h[1];
            if (s && h[2]) {
              if (m === i && !(d in e))
                return !1;
            } else {
              var E = new tn();
              if (r)
                var A = r(m, x, d, e, n, E);
              if (!(A === i ? tr(x, m, se | ve, r, E) : A))
                return !1;
            }
          }
          return !0;
        }
        function Qa(e) {
          if (!ue(e) || Dl(e))
            return !1;
          var n = Sn(e) ? Qs : me;
          return n.test(ut(e));
        }
        function jc(e) {
          return fe(e) && Se(e) == Vn;
        }
        function el(e) {
          return fe(e) && Re(e) == Fe;
        }
        function nl(e) {
          return fe(e) && oi(e.length) && !!te[Se(e)];
        }
        function ja(e) {
          return typeof e == "function" ? e : e == null ? Pe : typeof e == "object" ? W(e) ? tf(e[0], e[1]) : nf(e) : Ro(e);
        }
        function iu(e) {
          if (!ur(e))
            return ic(e);
          var n = [];
          for (var t in ee(e))
            Q.call(e, t) && t != "constructor" && n.push(t);
          return n;
        }
        function tl(e) {
          if (!ue(e))
            return Nl(e);
          var n = ur(e), t = [];
          for (var r in e)
            r == "constructor" && (n || !Q.call(e, r)) || t.push(r);
          return t;
        }
        function uu(e, n) {
          return e < n;
        }
        function ef(e, n) {
          var t = -1, r = Oe(e) ? p(e.length) : [];
          return Nn(e, function(u, f, s) {
            r[++t] = n(u, f, s);
          }), r;
        }
        function nf(e) {
          var n = xu(e);
          return n.length == 1 && n[0][2] ? Mf(n[0][0], n[0][1]) : function(t) {
            return t === e || ru(t, e, n);
          };
        }
        function tf(e, n) {
          return yu(e) && Ff(n) ? Mf(hn(e), n) : function(t) {
            var r = Pu(t, e);
            return r === i && r === n ? Uu(t, e) : tr(n, r, se | ve);
          };
        }
        function Kr(e, n, t, r, u) {
          e !== n && ji(n, function(f, s) {
            if (u || (u = new tn()), ue(f))
              rl(e, n, s, t, Kr, r, u);
            else {
              var h = r ? r(Au(e, s), f, s + "", e, n, u) : i;
              h === i && (h = f), Vi(e, s, h);
            }
          }, Le);
        }
        function rl(e, n, t, r, u, f, s) {
          var h = Au(e, t), d = Au(n, t), m = s.get(d);
          if (m) {
            Vi(e, t, m);
            return;
          }
          var x = f ? f(h, d, t + "", e, n, s) : i, E = x === i;
          if (E) {
            var A = W(d), I = !A && Gn(d), P = !A && !I && Lt(d);
            x = d, A || I || P ? W(h) ? x = h : ce(h) ? x = be(h) : I ? (E = !1, x = pf(d, !0)) : P ? (E = !1, x = _f(d, !0)) : x = [] : fr(d) || at(d) ? (x = h, at(h) ? x = ho(h) : (!ue(h) || Sn(h)) && (x = Df(d))) : E = !1;
          }
          E && (s.set(d, x), u(x, d, r, f, s), s.delete(d)), Vi(e, t, x);
        }
        function rf(e, n) {
          var t = e.length;
          if (t)
            return n += n < 0 ? t : 0, An(n, t) ? e[n] : i;
        }
        function uf(e, n, t) {
          n.length ? n = re(n, function(f) {
            return W(f) ? function(s) {
              return rt(s, f.length === 1 ? f[0] : f);
            } : f;
          }) : n = [Pe];
          var r = -1;
          n = re(n, We(O()));
          var u = ef(e, function(f, s, h) {
            var d = re(n, function(m) {
              return m(f);
            });
            return { criteria: d, index: ++r, value: f };
          });
          return Os(u, function(f, s) {
            return _l(f, s, t);
          });
        }
        function il(e, n) {
          return af(e, n, function(t, r) {
            return Uu(e, r);
          });
        }
        function af(e, n, t) {
          for (var r = -1, u = n.length, f = {}; ++r < u; ) {
            var s = n[r], h = rt(e, s);
            t(h, s) && rr(f, kn(s, e), h);
          }
          return f;
        }
        function ul(e) {
          return function(n) {
            return rt(n, e);
          };
        }
        function au(e, n, t, r) {
          var u = r ? bs : xt, f = -1, s = n.length, h = e;
          for (e === n && (n = be(n)), t && (h = re(e, We(t))); ++f < s; )
            for (var d = 0, m = n[f], x = t ? t(m) : m; (d = u(h, x, d, r)) > -1; )
              h !== e && Mr.call(h, d, 1), Mr.call(e, d, 1);
          return e;
        }
        function ff(e, n) {
          for (var t = e ? n.length : 0, r = t - 1; t--; ) {
            var u = n[t];
            if (t == r || u !== f) {
              var f = u;
              An(u) ? Mr.call(e, u, 1) : cu(e, u);
            }
          }
          return e;
        }
        function fu(e, n) {
          return e + Br(ka() * (n - e + 1));
        }
        function al(e, n, t, r) {
          for (var u = -1, f = de(Nr((n - e) / (t || 1)), 0), s = p(f); f--; )
            s[r ? f : ++u] = e, e += t;
          return s;
        }
        function ou(e, n) {
          var t = "";
          if (!e || n < 1 || n > pn)
            return t;
          do
            n % 2 && (t += e), n = Br(n / 2), n && (e += e);
          while (n);
          return t;
        }
        function $(e, n) {
          return Su(Wf(e, n, Pe), e + "");
        }
        function fl(e) {
          return za(Pt(e));
        }
        function ol(e, n) {
          var t = Pt(e);
          return ti(t, tt(n, 0, t.length));
        }
        function rr(e, n, t, r) {
          if (!ue(e))
            return e;
          n = kn(n, e);
          for (var u = -1, f = n.length, s = f - 1, h = e; h != null && ++u < f; ) {
            var d = hn(n[u]), m = t;
            if (d === "__proto__" || d === "constructor" || d === "prototype")
              return e;
            if (u != s) {
              var x = h[d];
              m = r ? r(x, d, h) : i, m === i && (m = ue(x) ? x : An(n[u + 1]) ? [] : {});
            }
            jt(h, d, m), h = h[d];
          }
          return e;
        }
        var of = kr ? function(e, n) {
          return kr.set(e, n), e;
        } : Pe, sl = Wr ? function(e, n) {
          return Wr(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: Fu(n),
            writable: !0
          });
        } : Pe;
        function cl(e) {
          return ti(Pt(e));
        }
        function Ze(e, n, t) {
          var r = -1, u = e.length;
          n < 0 && (n = -n > u ? 0 : u + n), t = t > u ? u : t, t < 0 && (t += u), u = n > t ? 0 : t - n >>> 0, n >>>= 0;
          for (var f = p(u); ++r < u; )
            f[r] = e[r + n];
          return f;
        }
        function ll(e, n) {
          var t;
          return Nn(e, function(r, u, f) {
            return t = n(r, u, f), !t;
          }), !!t;
        }
        function qr(e, n, t) {
          var r = 0, u = e == null ? r : e.length;
          if (typeof n == "number" && n === n && u <= vr) {
            for (; r < u; ) {
              var f = r + u >>> 1, s = e[f];
              s !== null && !Be(s) && (t ? s <= n : s < n) ? r = f + 1 : u = f;
            }
            return u;
          }
          return su(e, n, Pe, t);
        }
        function su(e, n, t, r) {
          var u = 0, f = e == null ? 0 : e.length;
          if (f === 0)
            return 0;
          n = t(n);
          for (var s = n !== n, h = n === null, d = Be(n), m = n === i; u < f; ) {
            var x = Br((u + f) / 2), E = t(e[x]), A = E !== i, I = E === null, P = E === E, k = Be(E);
            if (s)
              var U = r || P;
            else m ? U = P && (r || A) : h ? U = P && A && (r || !I) : d ? U = P && A && !I && (r || !k) : I || k ? U = !1 : U = r ? E <= n : E < n;
            U ? u = x + 1 : f = x;
          }
          return ye(f, _r);
        }
        function sf(e, n) {
          for (var t = -1, r = e.length, u = 0, f = []; ++t < r; ) {
            var s = e[t], h = n ? n(s) : s;
            if (!t || !rn(h, d)) {
              var d = h;
              f[u++] = s === 0 ? 0 : s;
            }
          }
          return f;
        }
        function cf(e) {
          return typeof e == "number" ? e : Be(e) ? Zn : +e;
        }
        function Ne(e) {
          if (typeof e == "string")
            return e;
          if (W(e))
            return re(e, Ne) + "";
          if (Be(e))
            return $a ? $a.call(e) : "";
          var n = e + "";
          return n == "0" && 1 / e == -1 / 0 ? "-0" : n;
        }
        function Bn(e, n, t) {
          var r = -1, u = Tr, f = e.length, s = !0, h = [], d = h;
          if (t)
            s = !1, u = Ni;
          else if (f >= w) {
            var m = n ? null : yl(e);
            if (m)
              return Ir(m);
            s = !1, u = qt, d = new nt();
          } else
            d = n ? [] : h;
          e:
            for (; ++r < f; ) {
              var x = e[r], E = n ? n(x) : x;
              if (x = t || x !== 0 ? x : 0, s && E === E) {
                for (var A = d.length; A--; )
                  if (d[A] === E)
                    continue e;
                n && d.push(E), h.push(x);
              } else u(d, E, t) || (d !== h && d.push(E), h.push(x));
            }
          return h;
        }
        function cu(e, n) {
          return n = kn(n, e), e = Nf(e, n), e == null || delete e[hn(Je(n))];
        }
        function lf(e, n, t, r) {
          return rr(e, n, t(rt(e, n)), r);
        }
        function Zr(e, n, t, r) {
          for (var u = e.length, f = r ? u : -1; (r ? f-- : ++f < u) && n(e[f], f, e); )
            ;
          return t ? Ze(e, r ? 0 : f, r ? f + 1 : u) : Ze(e, r ? f + 1 : 0, r ? u : f);
        }
        function hf(e, n) {
          var t = e;
          return t instanceof Y && (t = t.value()), Bi(n, function(r, u) {
            return u.func.apply(u.thisArg, Fn([r], u.args));
          }, t);
        }
        function lu(e, n, t) {
          var r = e.length;
          if (r < 2)
            return r ? Bn(e[0]) : [];
          for (var u = -1, f = p(r); ++u < r; )
            for (var s = e[u], h = -1; ++h < r; )
              h != u && (f[u] = er(f[u] || s, e[h], n, t));
          return Bn(Ee(f, 1), n, t);
        }
        function gf(e, n, t) {
          for (var r = -1, u = e.length, f = n.length, s = {}; ++r < u; ) {
            var h = r < f ? n[r] : i;
            t(s, e[r], h);
          }
          return s;
        }
        function hu(e) {
          return ce(e) ? e : [];
        }
        function gu(e) {
          return typeof e == "function" ? e : Pe;
        }
        function kn(e, n) {
          return W(e) ? e : yu(e, n) ? [e] : Gf(V(e));
        }
        var hl = $;
        function $n(e, n, t) {
          var r = e.length;
          return t = t === i ? r : t, !n && t >= r ? e : Ze(e, n, t);
        }
        var df = js || function(e) {
          return xe.clearTimeout(e);
        };
        function pf(e, n) {
          if (n)
            return e.slice();
          var t = e.length, r = Fa ? Fa(t) : new e.constructor(t);
          return e.copy(r), r;
        }
        function du(e) {
          var n = new e.constructor(e.byteLength);
          return new Dr(n).set(new Dr(e)), n;
        }
        function gl(e, n) {
          var t = n ? du(e.buffer) : e.buffer;
          return new e.constructor(t, e.byteOffset, e.byteLength);
        }
        function dl(e) {
          var n = new e.constructor(e.source, X.exec(e));
          return n.lastIndex = e.lastIndex, n;
        }
        function pl(e) {
          return Qt ? ee(Qt.call(e)) : {};
        }
        function _f(e, n) {
          var t = n ? du(e.buffer) : e.buffer;
          return new e.constructor(t, e.byteOffset, e.length);
        }
        function vf(e, n) {
          if (e !== n) {
            var t = e !== i, r = e === null, u = e === e, f = Be(e), s = n !== i, h = n === null, d = n === n, m = Be(n);
            if (!h && !m && !f && e > n || f && s && d && !h && !m || r && s && d || !t && d || !u)
              return 1;
            if (!r && !f && !m && e < n || m && t && u && !r && !f || h && t && u || !s && u || !d)
              return -1;
          }
          return 0;
        }
        function _l(e, n, t) {
          for (var r = -1, u = e.criteria, f = n.criteria, s = u.length, h = t.length; ++r < s; ) {
            var d = vf(u[r], f[r]);
            if (d) {
              if (r >= h)
                return d;
              var m = t[r];
              return d * (m == "desc" ? -1 : 1);
            }
          }
          return e.index - n.index;
        }
        function wf(e, n, t, r) {
          for (var u = -1, f = e.length, s = t.length, h = -1, d = n.length, m = de(f - s, 0), x = p(d + m), E = !r; ++h < d; )
            x[h] = n[h];
          for (; ++u < s; )
            (E || u < f) && (x[t[u]] = e[u]);
          for (; m--; )
            x[h++] = e[u++];
          return x;
        }
        function mf(e, n, t, r) {
          for (var u = -1, f = e.length, s = -1, h = t.length, d = -1, m = n.length, x = de(f - h, 0), E = p(x + m), A = !r; ++u < x; )
            E[u] = e[u];
          for (var I = u; ++d < m; )
            E[I + d] = n[d];
          for (; ++s < h; )
            (A || u < f) && (E[I + t[s]] = e[u++]);
          return E;
        }
        function be(e, n) {
          var t = -1, r = e.length;
          for (n || (n = p(r)); ++t < r; )
            n[t] = e[t];
          return n;
        }
        function ln(e, n, t, r) {
          var u = !t;
          t || (t = {});
          for (var f = -1, s = n.length; ++f < s; ) {
            var h = n[f], d = r ? r(t[h], e[h], h, t, e) : i;
            d === i && (d = e[h]), u ? En(t, h, d) : jt(t, h, d);
          }
          return t;
        }
        function vl(e, n) {
          return ln(e, Eu(e), n);
        }
        function wl(e, n) {
          return ln(e, Pf(e), n);
        }
        function Jr(e, n) {
          return function(t, r) {
            var u = W(t) ? Rs : kc, f = n ? n() : {};
            return u(t, e, O(r, 2), f);
          };
        }
        function It(e) {
          return $(function(n, t) {
            var r = -1, u = t.length, f = u > 1 ? t[u - 1] : i, s = u > 2 ? t[2] : i;
            for (f = e.length > 3 && typeof f == "function" ? (u--, f) : i, s && Te(t[0], t[1], s) && (f = u < 3 ? i : f, u = 1), n = ee(n); ++r < u; ) {
              var h = t[r];
              h && e(n, h, r, f);
            }
            return n;
          });
        }
        function xf(e, n) {
          return function(t, r) {
            if (t == null)
              return t;
            if (!Oe(t))
              return e(t, r);
            for (var u = t.length, f = n ? u : -1, s = ee(t); (n ? f-- : ++f < u) && r(s[f], f, s) !== !1; )
              ;
            return t;
          };
        }
        function Ef(e) {
          return function(n, t, r) {
            for (var u = -1, f = ee(n), s = r(n), h = s.length; h--; ) {
              var d = s[e ? h : ++u];
              if (t(f[d], d, f) === !1)
                break;
            }
            return n;
          };
        }
        function ml(e, n, t) {
          var r = n & we, u = ir(e);
          function f() {
            var s = this && this !== xe && this instanceof f ? u : e;
            return s.apply(r ? t : this, arguments);
          }
          return f;
        }
        function yf(e) {
          return function(n) {
            n = V(n);
            var t = Et(n) ? nn(n) : i, r = t ? t[0] : n.charAt(0), u = t ? $n(t, 1).join("") : n.slice(1);
            return r[e]() + u;
          };
        }
        function bt(e) {
          return function(n) {
            return Bi(Eo(xo(n).replace(ss, "")), e, "");
          };
        }
        function ir(e) {
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return new e();
              case 1:
                return new e(n[0]);
              case 2:
                return new e(n[0], n[1]);
              case 3:
                return new e(n[0], n[1], n[2]);
              case 4:
                return new e(n[0], n[1], n[2], n[3]);
              case 5:
                return new e(n[0], n[1], n[2], n[3], n[4]);
              case 6:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5]);
              case 7:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
            }
            var t = Ct(e.prototype), r = e.apply(t, n);
            return ue(r) ? r : t;
          };
        }
        function xl(e, n, t) {
          var r = ir(e);
          function u() {
            for (var f = arguments.length, s = p(f), h = f, d = Ot(u); h--; )
              s[h] = arguments[h];
            var m = f < 3 && s[0] !== d && s[f - 1] !== d ? [] : Mn(s, d);
            if (f -= m.length, f < t)
              return Cf(
                e,
                n,
                Xr,
                u.placeholder,
                i,
                s,
                m,
                i,
                i,
                t - f
              );
            var x = this && this !== xe && this instanceof u ? r : e;
            return Me(x, this, s);
          }
          return u;
        }
        function Rf(e) {
          return function(n, t, r) {
            var u = ee(n);
            if (!Oe(n)) {
              var f = O(t, 3);
              n = _e(n), t = function(h) {
                return f(u[h], h, u);
              };
            }
            var s = e(n, t, r);
            return s > -1 ? u[f ? n[s] : s] : i;
          };
        }
        function Af(e) {
          return Rn(function(n) {
            var t = n.length, r = t, u = Ke.prototype.thru;
            for (e && n.reverse(); r--; ) {
              var f = n[r];
              if (typeof f != "function")
                throw new Ye(T);
              if (u && !s && ei(f) == "wrapper")
                var s = new Ke([], !0);
            }
            for (r = s ? r : t; ++r < t; ) {
              f = n[r];
              var h = ei(f), d = h == "wrapper" ? mu(f) : i;
              d && Ru(d[0]) && d[1] == (je | Ve | Qe | Yn) && !d[4].length && d[9] == 1 ? s = s[ei(d[0])].apply(s, d[3]) : s = f.length == 1 && Ru(f) ? s[h]() : s.thru(f);
            }
            return function() {
              var m = arguments, x = m[0];
              if (s && m.length == 1 && W(x))
                return s.plant(x).value();
              for (var E = 0, A = t ? n[E].apply(this, m) : x; ++E < t; )
                A = n[E].call(this, A);
              return A;
            };
          });
        }
        function Xr(e, n, t, r, u, f, s, h, d, m) {
          var x = n & je, E = n & we, A = n & Ae, I = n & (Ve | zn), P = n & st, k = A ? i : ir(e);
          function U() {
            for (var z = arguments.length, q = p(z), ke = z; ke--; )
              q[ke] = arguments[ke];
            if (I)
              var Ce = Ot(U), $e = Ps(q, Ce);
            if (r && (q = wf(q, r, u, I)), f && (q = mf(q, f, s, I)), z -= $e, I && z < m) {
              var le = Mn(q, Ce);
              return Cf(
                e,
                n,
                Xr,
                U.placeholder,
                t,
                q,
                le,
                h,
                d,
                m - z
              );
            }
            var un = E ? t : this, Cn = A ? un[e] : e;
            return z = q.length, h ? q = kl(q, h) : P && z > 1 && q.reverse(), x && d < z && (q.length = d), this && this !== xe && this instanceof U && (Cn = k || ir(Cn)), Cn.apply(un, q);
          }
          return U;
        }
        function Sf(e, n) {
          return function(t, r) {
            return Zc(t, e, n(r), {});
          };
        }
        function Vr(e, n) {
          return function(t, r) {
            var u;
            if (t === i && r === i)
              return n;
            if (t !== i && (u = t), r !== i) {
              if (u === i)
                return r;
              typeof t == "string" || typeof r == "string" ? (t = Ne(t), r = Ne(r)) : (t = cf(t), r = cf(r)), u = e(t, r);
            }
            return u;
          };
        }
        function pu(e) {
          return Rn(function(n) {
            return n = re(n, We(O())), $(function(t) {
              var r = this;
              return e(n, function(u) {
                return Me(u, r, t);
              });
            });
          });
        }
        function Qr(e, n) {
          n = n === i ? " " : Ne(n);
          var t = n.length;
          if (t < 2)
            return t ? ou(n, e) : n;
          var r = ou(n, Nr(e / yt(n)));
          return Et(n) ? $n(nn(r), 0, e).join("") : r.slice(0, e);
        }
        function El(e, n, t, r) {
          var u = n & we, f = ir(e);
          function s() {
            for (var h = -1, d = arguments.length, m = -1, x = r.length, E = p(x + d), A = this && this !== xe && this instanceof s ? f : e; ++m < x; )
              E[m] = r[m];
            for (; d--; )
              E[m++] = arguments[++h];
            return Me(A, u ? t : this, E);
          }
          return s;
        }
        function Tf(e) {
          return function(n, t, r) {
            return r && typeof r != "number" && Te(n, t, r) && (t = r = i), n = Tn(n), t === i ? (t = n, n = 0) : t = Tn(t), r = r === i ? n < t ? 1 : -1 : Tn(r), al(n, t, r, e);
          };
        }
        function jr(e) {
          return function(n, t) {
            return typeof n == "string" && typeof t == "string" || (n = Xe(n), t = Xe(t)), e(n, t);
          };
        }
        function Cf(e, n, t, r, u, f, s, h, d, m) {
          var x = n & Ve, E = x ? s : i, A = x ? i : s, I = x ? f : i, P = x ? i : f;
          n |= x ? Qe : Hn, n &= ~(x ? Hn : Qe), n & pe || (n &= -4);
          var k = [
            e,
            n,
            u,
            I,
            E,
            P,
            A,
            h,
            d,
            m
          ], U = t.apply(i, k);
          return Ru(e) && Bf(U, k), U.placeholder = r, kf(U, e, n);
        }
        function _u(e) {
          var n = ge[e];
          return function(t, r) {
            if (t = Xe(t), r = r == null ? 0 : ye(N(r), 292), r && Ba(t)) {
              var u = (V(t) + "e").split("e"), f = n(u[0] + "e" + (+u[1] + r));
              return u = (V(f) + "e").split("e"), +(u[0] + "e" + (+u[1] - r));
            }
            return n(t);
          };
        }
        var yl = St && 1 / Ir(new St([, -0]))[1] == qn ? function(e) {
          return new St(e);
        } : Nu;
        function If(e) {
          return function(n) {
            var t = Re(n);
            return t == De ? Ki(n) : t == Fe ? Bs(n) : Ls(n, e(n));
          };
        }
        function yn(e, n, t, r, u, f, s, h) {
          var d = n & Ae;
          if (!d && typeof e != "function")
            throw new Ye(T);
          var m = r ? r.length : 0;
          if (m || (n &= -97, r = u = i), s = s === i ? s : de(N(s), 0), h = h === i ? h : N(h), m -= u ? u.length : 0, n & Hn) {
            var x = r, E = u;
            r = u = i;
          }
          var A = d ? i : mu(e), I = [
            e,
            n,
            t,
            r,
            u,
            x,
            E,
            f,
            s,
            h
          ];
          if (A && Wl(I, A), e = I[0], n = I[1], t = I[2], r = I[3], u = I[4], h = I[9] = I[9] === i ? d ? 0 : e.length : de(I[9] - m, 0), !h && n & (Ve | zn) && (n &= -25), !n || n == we)
            var P = ml(e, n, t);
          else n == Ve || n == zn ? P = xl(e, n, h) : (n == Qe || n == (we | Qe)) && !u.length ? P = El(e, n, t, r) : P = Xr.apply(i, I);
          var k = A ? of : Bf;
          return kf(k(P, I), e, n);
        }
        function bf(e, n, t, r) {
          return e === i || rn(e, At[t]) && !Q.call(r, t) ? n : e;
        }
        function Of(e, n, t, r, u, f) {
          return ue(e) && ue(n) && (f.set(n, e), Kr(e, n, i, Of, f), f.delete(n)), e;
        }
        function Rl(e) {
          return fr(e) ? i : e;
        }
        function Lf(e, n, t, r, u, f) {
          var s = t & se, h = e.length, d = n.length;
          if (h != d && !(s && d > h))
            return !1;
          var m = f.get(e), x = f.get(n);
          if (m && x)
            return m == n && x == e;
          var E = -1, A = !0, I = t & ve ? new nt() : i;
          for (f.set(e, n), f.set(n, e); ++E < h; ) {
            var P = e[E], k = n[E];
            if (r)
              var U = s ? r(k, P, E, n, e, f) : r(P, k, E, e, n, f);
            if (U !== i) {
              if (U)
                continue;
              A = !1;
              break;
            }
            if (I) {
              if (!ki(n, function(z, q) {
                if (!qt(I, q) && (P === z || u(P, z, t, r, f)))
                  return I.push(q);
              })) {
                A = !1;
                break;
              }
            } else if (!(P === k || u(P, k, t, r, f))) {
              A = !1;
              break;
            }
          }
          return f.delete(e), f.delete(n), A;
        }
        function Al(e, n, t, r, u, f, s) {
          switch (t) {
            case Pn:
              if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset)
                return !1;
              e = e.buffer, n = n.buffer;
            case Ln:
              return !(e.byteLength != n.byteLength || !f(new Dr(e), new Dr(n)));
            case on:
            case _n:
            case sn:
              return rn(+e, +n);
            case lt:
              return e.name == n.name && e.message == n.message;
            case Vn:
            case vn:
              return e == n + "";
            case De:
              var h = Ki;
            case Fe:
              var d = r & se;
              if (h || (h = Ir), e.size != n.size && !d)
                return !1;
              var m = s.get(e);
              if (m)
                return m == n;
              r |= ve, s.set(e, n);
              var x = Lf(h(e), h(n), r, u, f, s);
              return s.delete(e), x;
            case gt:
              if (Qt)
                return Qt.call(e) == Qt.call(n);
          }
          return !1;
        }
        function Sl(e, n, t, r, u, f) {
          var s = t & se, h = vu(e), d = h.length, m = vu(n), x = m.length;
          if (d != x && !s)
            return !1;
          for (var E = d; E--; ) {
            var A = h[E];
            if (!(s ? A in n : Q.call(n, A)))
              return !1;
          }
          var I = f.get(e), P = f.get(n);
          if (I && P)
            return I == n && P == e;
          var k = !0;
          f.set(e, n), f.set(n, e);
          for (var U = s; ++E < d; ) {
            A = h[E];
            var z = e[A], q = n[A];
            if (r)
              var ke = s ? r(q, z, A, n, e, f) : r(z, q, A, e, n, f);
            if (!(ke === i ? z === q || u(z, q, t, r, f) : ke)) {
              k = !1;
              break;
            }
            U || (U = A == "constructor");
          }
          if (k && !U) {
            var Ce = e.constructor, $e = n.constructor;
            Ce != $e && "constructor" in e && "constructor" in n && !(typeof Ce == "function" && Ce instanceof Ce && typeof $e == "function" && $e instanceof $e) && (k = !1);
          }
          return f.delete(e), f.delete(n), k;
        }
        function Rn(e) {
          return Su(Wf(e, i, Kf), e + "");
        }
        function vu(e) {
          return Xa(e, _e, Eu);
        }
        function wu(e) {
          return Xa(e, Le, Pf);
        }
        var mu = kr ? function(e) {
          return kr.get(e);
        } : Nu;
        function ei(e) {
          for (var n = e.name + "", t = Tt[n], r = Q.call(Tt, n) ? t.length : 0; r--; ) {
            var u = t[r], f = u.func;
            if (f == null || f == e)
              return u.name;
          }
          return n;
        }
        function Ot(e) {
          var n = Q.call(a, "placeholder") ? a : e;
          return n.placeholder;
        }
        function O() {
          var e = a.iteratee || Mu;
          return e = e === Mu ? ja : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function ni(e, n) {
          var t = e.__data__;
          return Ul(n) ? t[typeof n == "string" ? "string" : "hash"] : t.map;
        }
        function xu(e) {
          for (var n = _e(e), t = n.length; t--; ) {
            var r = n[t], u = e[r];
            n[t] = [r, u, Ff(u)];
          }
          return n;
        }
        function it(e, n) {
          var t = Ms(e, n);
          return Qa(t) ? t : i;
        }
        function Tl(e) {
          var n = Q.call(e, jn), t = e[jn];
          try {
            e[jn] = i;
            var r = !0;
          } catch {
          }
          var u = Pr.call(e);
          return r && (n ? e[jn] = t : delete e[jn]), u;
        }
        var Eu = Zi ? function(e) {
          return e == null ? [] : (e = ee(e), Dn(Zi(e), function(n) {
            return Wa.call(e, n);
          }));
        } : Bu, Pf = Zi ? function(e) {
          for (var n = []; e; )
            Fn(n, Eu(e)), e = Fr(e);
          return n;
        } : Bu, Re = Se;
        (Ji && Re(new Ji(new ArrayBuffer(1))) != Pn || Jt && Re(new Jt()) != De || Xi && Re(Xi.resolve()) != Ft || St && Re(new St()) != Fe || Xt && Re(new Xt()) != On) && (Re = function(e) {
          var n = Se(e), t = n == Ge ? e.constructor : i, r = t ? ut(t) : "";
          if (r)
            switch (r) {
              case oc:
                return Pn;
              case sc:
                return De;
              case cc:
                return Ft;
              case lc:
                return Fe;
              case hc:
                return On;
            }
          return n;
        });
        function Cl(e, n, t) {
          for (var r = -1, u = t.length; ++r < u; ) {
            var f = t[r], s = f.size;
            switch (f.type) {
              case "drop":
                e += s;
                break;
              case "dropRight":
                n -= s;
                break;
              case "take":
                n = ye(n, e + s);
                break;
              case "takeRight":
                e = de(e, n - s);
                break;
            }
          }
          return { start: e, end: n };
        }
        function Il(e) {
          var n = e.match(Ii);
          return n ? n[1].split(l) : [];
        }
        function Uf(e, n, t) {
          n = kn(n, e);
          for (var r = -1, u = n.length, f = !1; ++r < u; ) {
            var s = hn(n[r]);
            if (!(f = e != null && t(e, s)))
              break;
            e = e[s];
          }
          return f || ++r != u ? f : (u = e == null ? 0 : e.length, !!u && oi(u) && An(s, u) && (W(e) || at(e)));
        }
        function bl(e) {
          var n = e.length, t = new e.constructor(n);
          return n && typeof e[0] == "string" && Q.call(e, "index") && (t.index = e.index, t.input = e.input), t;
        }
        function Df(e) {
          return typeof e.constructor == "function" && !ur(e) ? Ct(Fr(e)) : {};
        }
        function Ol(e, n, t) {
          var r = e.constructor;
          switch (n) {
            case Ln:
              return du(e);
            case on:
            case _n:
              return new r(+e);
            case Pn:
              return gl(e, t);
            case dt:
            case pt:
            case Mt:
            case Wt:
            case Nt:
            case Bt:
            case kt:
            case $t:
            case Gt:
              return _f(e, t);
            case De:
              return new r();
            case sn:
            case vn:
              return new r(e);
            case Vn:
              return dl(e);
            case Fe:
              return new r();
            case gt:
              return pl(e);
          }
        }
        function Ll(e, n) {
          var t = n.length;
          if (!t)
            return e;
          var r = t - 1;
          return n[r] = (t > 1 ? "& " : "") + n[r], n = n.join(t > 2 ? ", " : " "), e.replace(Ci, `{
/* [wrapped with ` + n + `] */
`);
        }
        function Pl(e) {
          return W(e) || at(e) || !!(Na && e && e[Na]);
        }
        function An(e, n) {
          var t = typeof e;
          return n = n ?? pn, !!n && (t == "number" || t != "symbol" && ae.test(e)) && e > -1 && e % 1 == 0 && e < n;
        }
        function Te(e, n, t) {
          if (!ue(t))
            return !1;
          var r = typeof n;
          return (r == "number" ? Oe(t) && An(n, t.length) : r == "string" && n in t) ? rn(t[n], e) : !1;
        }
        function yu(e, n) {
          if (W(e))
            return !1;
          var t = typeof e;
          return t == "number" || t == "symbol" || t == "boolean" || e == null || Be(e) ? !0 : Ai.test(e) || !Rr.test(e) || n != null && e in ee(n);
        }
        function Ul(e) {
          var n = typeof e;
          return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
        }
        function Ru(e) {
          var n = ei(e), t = a[n];
          if (typeof t != "function" || !(n in Y.prototype))
            return !1;
          if (e === t)
            return !0;
          var r = mu(t);
          return !!r && e === r[0];
        }
        function Dl(e) {
          return !!Da && Da in e;
        }
        var Fl = Or ? Sn : ku;
        function ur(e) {
          var n = e && e.constructor, t = typeof n == "function" && n.prototype || At;
          return e === t;
        }
        function Ff(e) {
          return e === e && !ue(e);
        }
        function Mf(e, n) {
          return function(t) {
            return t == null ? !1 : t[e] === n && (n !== i || e in ee(t));
          };
        }
        function Ml(e) {
          var n = ai(e, function(r) {
            return t.size === K && t.clear(), r;
          }), t = n.cache;
          return n;
        }
        function Wl(e, n) {
          var t = e[1], r = n[1], u = t | r, f = u < (we | Ae | je), s = r == je && t == Ve || r == je && t == Yn && e[7].length <= n[8] || r == (je | Yn) && n[7].length <= n[8] && t == Ve;
          if (!(f || s))
            return e;
          r & we && (e[2] = n[2], u |= t & we ? 0 : pe);
          var h = n[3];
          if (h) {
            var d = e[3];
            e[3] = d ? wf(d, h, n[4]) : h, e[4] = d ? Mn(e[3], L) : n[4];
          }
          return h = n[5], h && (d = e[5], e[5] = d ? mf(d, h, n[6]) : h, e[6] = d ? Mn(e[5], L) : n[6]), h = n[7], h && (e[7] = h), r & je && (e[8] = e[8] == null ? n[8] : ye(e[8], n[8])), e[9] == null && (e[9] = n[9]), e[0] = n[0], e[1] = u, e;
        }
        function Nl(e) {
          var n = [];
          if (e != null)
            for (var t in ee(e))
              n.push(t);
          return n;
        }
        function Bl(e) {
          return Pr.call(e);
        }
        function Wf(e, n, t) {
          return n = de(n === i ? e.length - 1 : n, 0), function() {
            for (var r = arguments, u = -1, f = de(r.length - n, 0), s = p(f); ++u < f; )
              s[u] = r[n + u];
            u = -1;
            for (var h = p(n + 1); ++u < n; )
              h[u] = r[u];
            return h[n] = t(s), Me(e, this, h);
          };
        }
        function Nf(e, n) {
          return n.length < 2 ? e : rt(e, Ze(n, 0, -1));
        }
        function kl(e, n) {
          for (var t = e.length, r = ye(n.length, t), u = be(e); r--; ) {
            var f = n[r];
            e[r] = An(f, t) ? u[f] : i;
          }
          return e;
        }
        function Au(e, n) {
          if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
            return e[n];
        }
        var Bf = $f(of), ar = nc || function(e, n) {
          return xe.setTimeout(e, n);
        }, Su = $f(sl);
        function kf(e, n, t) {
          var r = n + "";
          return Su(e, Ll(r, $l(Il(r), t)));
        }
        function $f(e) {
          var n = 0, t = 0;
          return function() {
            var r = uc(), u = an - (r - t);
            if (t = r, u > 0) {
              if (++n >= gr)
                return arguments[0];
            } else
              n = 0;
            return e.apply(i, arguments);
          };
        }
        function ti(e, n) {
          var t = -1, r = e.length, u = r - 1;
          for (n = n === i ? r : n; ++t < n; ) {
            var f = fu(t, u), s = e[f];
            e[f] = e[t], e[t] = s;
          }
          return e.length = n, e;
        }
        var Gf = Ml(function(e) {
          var n = [];
          return e.charCodeAt(0) === 46 && n.push(""), e.replace(Si, function(t, r, u, f) {
            n.push(u ? f.replace(D, "$1") : r || t);
          }), n;
        });
        function hn(e) {
          if (typeof e == "string" || Be(e))
            return e;
          var n = e + "";
          return n == "0" && 1 / e == -1 / 0 ? "-0" : n;
        }
        function ut(e) {
          if (e != null) {
            try {
              return Lr.call(e);
            } catch {
            }
            try {
              return e + "";
            } catch {
            }
          }
          return "";
        }
        function $l(e, n) {
          return He(xi, function(t) {
            var r = "_." + t[0];
            n & t[1] && !Tr(e, r) && e.push(r);
          }), e.sort();
        }
        function zf(e) {
          if (e instanceof Y)
            return e.clone();
          var n = new Ke(e.__wrapped__, e.__chain__);
          return n.__actions__ = be(e.__actions__), n.__index__ = e.__index__, n.__values__ = e.__values__, n;
        }
        function Gl(e, n, t) {
          (t ? Te(e, n, t) : n === i) ? n = 1 : n = de(N(n), 0);
          var r = e == null ? 0 : e.length;
          if (!r || n < 1)
            return [];
          for (var u = 0, f = 0, s = p(Nr(r / n)); u < r; )
            s[f++] = Ze(e, u, u += n);
          return s;
        }
        function zl(e) {
          for (var n = -1, t = e == null ? 0 : e.length, r = 0, u = []; ++n < t; ) {
            var f = e[n];
            f && (u[r++] = f);
          }
          return u;
        }
        function Hl() {
          var e = arguments.length;
          if (!e)
            return [];
          for (var n = p(e - 1), t = arguments[0], r = e; r--; )
            n[r - 1] = arguments[r];
          return Fn(W(t) ? be(t) : [t], Ee(n, 1));
        }
        var Yl = $(function(e, n) {
          return ce(e) ? er(e, Ee(n, 1, ce, !0)) : [];
        }), Kl = $(function(e, n) {
          var t = Je(n);
          return ce(t) && (t = i), ce(e) ? er(e, Ee(n, 1, ce, !0), O(t, 2)) : [];
        }), ql = $(function(e, n) {
          var t = Je(n);
          return ce(t) && (t = i), ce(e) ? er(e, Ee(n, 1, ce, !0), i, t) : [];
        });
        function Zl(e, n, t) {
          var r = e == null ? 0 : e.length;
          return r ? (n = t || n === i ? 1 : N(n), Ze(e, n < 0 ? 0 : n, r)) : [];
        }
        function Jl(e, n, t) {
          var r = e == null ? 0 : e.length;
          return r ? (n = t || n === i ? 1 : N(n), n = r - n, Ze(e, 0, n < 0 ? 0 : n)) : [];
        }
        function Xl(e, n) {
          return e && e.length ? Zr(e, O(n, 3), !0, !0) : [];
        }
        function Vl(e, n) {
          return e && e.length ? Zr(e, O(n, 3), !0) : [];
        }
        function Ql(e, n, t, r) {
          var u = e == null ? 0 : e.length;
          return u ? (t && typeof t != "number" && Te(e, n, t) && (t = 0, r = u), Hc(e, n, t, r)) : [];
        }
        function Hf(e, n, t) {
          var r = e == null ? 0 : e.length;
          if (!r)
            return -1;
          var u = t == null ? 0 : N(t);
          return u < 0 && (u = de(r + u, 0)), Cr(e, O(n, 3), u);
        }
        function Yf(e, n, t) {
          var r = e == null ? 0 : e.length;
          if (!r)
            return -1;
          var u = r - 1;
          return t !== i && (u = N(t), u = t < 0 ? de(r + u, 0) : ye(u, r - 1)), Cr(e, O(n, 3), u, !0);
        }
        function Kf(e) {
          var n = e == null ? 0 : e.length;
          return n ? Ee(e, 1) : [];
        }
        function jl(e) {
          var n = e == null ? 0 : e.length;
          return n ? Ee(e, qn) : [];
        }
        function eh(e, n) {
          var t = e == null ? 0 : e.length;
          return t ? (n = n === i ? 1 : N(n), Ee(e, n)) : [];
        }
        function nh(e) {
          for (var n = -1, t = e == null ? 0 : e.length, r = {}; ++n < t; ) {
            var u = e[n];
            r[u[0]] = u[1];
          }
          return r;
        }
        function qf(e) {
          return e && e.length ? e[0] : i;
        }
        function th(e, n, t) {
          var r = e == null ? 0 : e.length;
          if (!r)
            return -1;
          var u = t == null ? 0 : N(t);
          return u < 0 && (u = de(r + u, 0)), xt(e, n, u);
        }
        function rh(e) {
          var n = e == null ? 0 : e.length;
          return n ? Ze(e, 0, -1) : [];
        }
        var ih = $(function(e) {
          var n = re(e, hu);
          return n.length && n[0] === e[0] ? tu(n) : [];
        }), uh = $(function(e) {
          var n = Je(e), t = re(e, hu);
          return n === Je(t) ? n = i : t.pop(), t.length && t[0] === e[0] ? tu(t, O(n, 2)) : [];
        }), ah = $(function(e) {
          var n = Je(e), t = re(e, hu);
          return n = typeof n == "function" ? n : i, n && t.pop(), t.length && t[0] === e[0] ? tu(t, i, n) : [];
        });
        function fh(e, n) {
          return e == null ? "" : rc.call(e, n);
        }
        function Je(e) {
          var n = e == null ? 0 : e.length;
          return n ? e[n - 1] : i;
        }
        function oh(e, n, t) {
          var r = e == null ? 0 : e.length;
          if (!r)
            return -1;
          var u = r;
          return t !== i && (u = N(t), u = u < 0 ? de(r + u, 0) : ye(u, r - 1)), n === n ? $s(e, n, u) : Cr(e, Ta, u, !0);
        }
        function sh(e, n) {
          return e && e.length ? rf(e, N(n)) : i;
        }
        var ch = $(Zf);
        function Zf(e, n) {
          return e && e.length && n && n.length ? au(e, n) : e;
        }
        function lh(e, n, t) {
          return e && e.length && n && n.length ? au(e, n, O(t, 2)) : e;
        }
        function hh(e, n, t) {
          return e && e.length && n && n.length ? au(e, n, i, t) : e;
        }
        var gh = Rn(function(e, n) {
          var t = e == null ? 0 : e.length, r = Qi(e, n);
          return ff(e, re(n, function(u) {
            return An(u, t) ? +u : u;
          }).sort(vf)), r;
        });
        function dh(e, n) {
          var t = [];
          if (!(e && e.length))
            return t;
          var r = -1, u = [], f = e.length;
          for (n = O(n, 3); ++r < f; ) {
            var s = e[r];
            n(s, r, e) && (t.push(s), u.push(r));
          }
          return ff(e, u), t;
        }
        function Tu(e) {
          return e == null ? e : fc.call(e);
        }
        function ph(e, n, t) {
          var r = e == null ? 0 : e.length;
          return r ? (t && typeof t != "number" && Te(e, n, t) ? (n = 0, t = r) : (n = n == null ? 0 : N(n), t = t === i ? r : N(t)), Ze(e, n, t)) : [];
        }
        function _h(e, n) {
          return qr(e, n);
        }
        function vh(e, n, t) {
          return su(e, n, O(t, 2));
        }
        function wh(e, n) {
          var t = e == null ? 0 : e.length;
          if (t) {
            var r = qr(e, n);
            if (r < t && rn(e[r], n))
              return r;
          }
          return -1;
        }
        function mh(e, n) {
          return qr(e, n, !0);
        }
        function xh(e, n, t) {
          return su(e, n, O(t, 2), !0);
        }
        function Eh(e, n) {
          var t = e == null ? 0 : e.length;
          if (t) {
            var r = qr(e, n, !0) - 1;
            if (rn(e[r], n))
              return r;
          }
          return -1;
        }
        function yh(e) {
          return e && e.length ? sf(e) : [];
        }
        function Rh(e, n) {
          return e && e.length ? sf(e, O(n, 2)) : [];
        }
        function Ah(e) {
          var n = e == null ? 0 : e.length;
          return n ? Ze(e, 1, n) : [];
        }
        function Sh(e, n, t) {
          return e && e.length ? (n = t || n === i ? 1 : N(n), Ze(e, 0, n < 0 ? 0 : n)) : [];
        }
        function Th(e, n, t) {
          var r = e == null ? 0 : e.length;
          return r ? (n = t || n === i ? 1 : N(n), n = r - n, Ze(e, n < 0 ? 0 : n, r)) : [];
        }
        function Ch(e, n) {
          return e && e.length ? Zr(e, O(n, 3), !1, !0) : [];
        }
        function Ih(e, n) {
          return e && e.length ? Zr(e, O(n, 3)) : [];
        }
        var bh = $(function(e) {
          return Bn(Ee(e, 1, ce, !0));
        }), Oh = $(function(e) {
          var n = Je(e);
          return ce(n) && (n = i), Bn(Ee(e, 1, ce, !0), O(n, 2));
        }), Lh = $(function(e) {
          var n = Je(e);
          return n = typeof n == "function" ? n : i, Bn(Ee(e, 1, ce, !0), i, n);
        });
        function Ph(e) {
          return e && e.length ? Bn(e) : [];
        }
        function Uh(e, n) {
          return e && e.length ? Bn(e, O(n, 2)) : [];
        }
        function Dh(e, n) {
          return n = typeof n == "function" ? n : i, e && e.length ? Bn(e, i, n) : [];
        }
        function Cu(e) {
          if (!(e && e.length))
            return [];
          var n = 0;
          return e = Dn(e, function(t) {
            if (ce(t))
              return n = de(t.length, n), !0;
          }), Hi(n, function(t) {
            return re(e, $i(t));
          });
        }
        function Jf(e, n) {
          if (!(e && e.length))
            return [];
          var t = Cu(e);
          return n == null ? t : re(t, function(r) {
            return Me(n, i, r);
          });
        }
        var Fh = $(function(e, n) {
          return ce(e) ? er(e, n) : [];
        }), Mh = $(function(e) {
          return lu(Dn(e, ce));
        }), Wh = $(function(e) {
          var n = Je(e);
          return ce(n) && (n = i), lu(Dn(e, ce), O(n, 2));
        }), Nh = $(function(e) {
          var n = Je(e);
          return n = typeof n == "function" ? n : i, lu(Dn(e, ce), i, n);
        }), Bh = $(Cu);
        function kh(e, n) {
          return gf(e || [], n || [], jt);
        }
        function $h(e, n) {
          return gf(e || [], n || [], rr);
        }
        var Gh = $(function(e) {
          var n = e.length, t = n > 1 ? e[n - 1] : i;
          return t = typeof t == "function" ? (e.pop(), t) : i, Jf(e, t);
        });
        function Xf(e) {
          var n = a(e);
          return n.__chain__ = !0, n;
        }
        function zh(e, n) {
          return n(e), e;
        }
        function ri(e, n) {
          return n(e);
        }
        var Hh = Rn(function(e) {
          var n = e.length, t = n ? e[0] : 0, r = this.__wrapped__, u = function(f) {
            return Qi(f, e);
          };
          return n > 1 || this.__actions__.length || !(r instanceof Y) || !An(t) ? this.thru(u) : (r = r.slice(t, +t + (n ? 1 : 0)), r.__actions__.push({
            func: ri,
            args: [u],
            thisArg: i
          }), new Ke(r, this.__chain__).thru(function(f) {
            return n && !f.length && f.push(i), f;
          }));
        });
        function Yh() {
          return Xf(this);
        }
        function Kh() {
          return new Ke(this.value(), this.__chain__);
        }
        function qh() {
          this.__values__ === i && (this.__values__ = co(this.value()));
          var e = this.__index__ >= this.__values__.length, n = e ? i : this.__values__[this.__index__++];
          return { done: e, value: n };
        }
        function Zh() {
          return this;
        }
        function Jh(e) {
          for (var n, t = this; t instanceof Gr; ) {
            var r = zf(t);
            r.__index__ = 0, r.__values__ = i, n ? u.__wrapped__ = r : n = r;
            var u = r;
            t = t.__wrapped__;
          }
          return u.__wrapped__ = e, n;
        }
        function Xh() {
          var e = this.__wrapped__;
          if (e instanceof Y) {
            var n = e;
            return this.__actions__.length && (n = new Y(this)), n = n.reverse(), n.__actions__.push({
              func: ri,
              args: [Tu],
              thisArg: i
            }), new Ke(n, this.__chain__);
          }
          return this.thru(Tu);
        }
        function Vh() {
          return hf(this.__wrapped__, this.__actions__);
        }
        var Qh = Jr(function(e, n, t) {
          Q.call(e, t) ? ++e[t] : En(e, t, 1);
        });
        function jh(e, n, t) {
          var r = W(e) ? Aa : zc;
          return t && Te(e, n, t) && (n = i), r(e, O(n, 3));
        }
        function eg(e, n) {
          var t = W(e) ? Dn : Za;
          return t(e, O(n, 3));
        }
        var ng = Rf(Hf), tg = Rf(Yf);
        function rg(e, n) {
          return Ee(ii(e, n), 1);
        }
        function ig(e, n) {
          return Ee(ii(e, n), qn);
        }
        function ug(e, n, t) {
          return t = t === i ? 1 : N(t), Ee(ii(e, n), t);
        }
        function Vf(e, n) {
          var t = W(e) ? He : Nn;
          return t(e, O(n, 3));
        }
        function Qf(e, n) {
          var t = W(e) ? As : qa;
          return t(e, O(n, 3));
        }
        var ag = Jr(function(e, n, t) {
          Q.call(e, t) ? e[t].push(n) : En(e, t, [n]);
        });
        function fg(e, n, t, r) {
          e = Oe(e) ? e : Pt(e), t = t && !r ? N(t) : 0;
          var u = e.length;
          return t < 0 && (t = de(u + t, 0)), si(e) ? t <= u && e.indexOf(n, t) > -1 : !!u && xt(e, n, t) > -1;
        }
        var og = $(function(e, n, t) {
          var r = -1, u = typeof n == "function", f = Oe(e) ? p(e.length) : [];
          return Nn(e, function(s) {
            f[++r] = u ? Me(n, s, t) : nr(s, n, t);
          }), f;
        }), sg = Jr(function(e, n, t) {
          En(e, t, n);
        });
        function ii(e, n) {
          var t = W(e) ? re : ef;
          return t(e, O(n, 3));
        }
        function cg(e, n, t, r) {
          return e == null ? [] : (W(n) || (n = n == null ? [] : [n]), t = r ? i : t, W(t) || (t = t == null ? [] : [t]), uf(e, n, t));
        }
        var lg = Jr(function(e, n, t) {
          e[t ? 0 : 1].push(n);
        }, function() {
          return [[], []];
        });
        function hg(e, n, t) {
          var r = W(e) ? Bi : Ia, u = arguments.length < 3;
          return r(e, O(n, 4), t, u, Nn);
        }
        function gg(e, n, t) {
          var r = W(e) ? Ss : Ia, u = arguments.length < 3;
          return r(e, O(n, 4), t, u, qa);
        }
        function dg(e, n) {
          var t = W(e) ? Dn : Za;
          return t(e, fi(O(n, 3)));
        }
        function pg(e) {
          var n = W(e) ? za : fl;
          return n(e);
        }
        function _g(e, n, t) {
          (t ? Te(e, n, t) : n === i) ? n = 1 : n = N(n);
          var r = W(e) ? Nc : ol;
          return r(e, n);
        }
        function vg(e) {
          var n = W(e) ? Bc : cl;
          return n(e);
        }
        function wg(e) {
          if (e == null)
            return 0;
          if (Oe(e))
            return si(e) ? yt(e) : e.length;
          var n = Re(e);
          return n == De || n == Fe ? e.size : iu(e).length;
        }
        function mg(e, n, t) {
          var r = W(e) ? ki : ll;
          return t && Te(e, n, t) && (n = i), r(e, O(n, 3));
        }
        var xg = $(function(e, n) {
          if (e == null)
            return [];
          var t = n.length;
          return t > 1 && Te(e, n[0], n[1]) ? n = [] : t > 2 && Te(n[0], n[1], n[2]) && (n = [n[0]]), uf(e, Ee(n, 1), []);
        }), ui = ec || function() {
          return xe.Date.now();
        };
        function Eg(e, n) {
          if (typeof n != "function")
            throw new Ye(T);
          return e = N(e), function() {
            if (--e < 1)
              return n.apply(this, arguments);
          };
        }
        function jf(e, n, t) {
          return n = t ? i : n, n = e && n == null ? e.length : n, yn(e, je, i, i, i, i, n);
        }
        function eo(e, n) {
          var t;
          if (typeof n != "function")
            throw new Ye(T);
          return e = N(e), function() {
            return --e > 0 && (t = n.apply(this, arguments)), e <= 1 && (n = i), t;
          };
        }
        var Iu = $(function(e, n, t) {
          var r = we;
          if (t.length) {
            var u = Mn(t, Ot(Iu));
            r |= Qe;
          }
          return yn(e, r, n, t, u);
        }), no = $(function(e, n, t) {
          var r = we | Ae;
          if (t.length) {
            var u = Mn(t, Ot(no));
            r |= Qe;
          }
          return yn(n, r, e, t, u);
        });
        function to(e, n, t) {
          n = t ? i : n;
          var r = yn(e, Ve, i, i, i, i, i, n);
          return r.placeholder = to.placeholder, r;
        }
        function ro(e, n, t) {
          n = t ? i : n;
          var r = yn(e, zn, i, i, i, i, i, n);
          return r.placeholder = ro.placeholder, r;
        }
        function io(e, n, t) {
          var r, u, f, s, h, d, m = 0, x = !1, E = !1, A = !0;
          if (typeof e != "function")
            throw new Ye(T);
          n = Xe(n) || 0, ue(t) && (x = !!t.leading, E = "maxWait" in t, f = E ? de(Xe(t.maxWait) || 0, n) : f, A = "trailing" in t ? !!t.trailing : A);
          function I(le) {
            var un = r, Cn = u;
            return r = u = i, m = le, s = e.apply(Cn, un), s;
          }
          function P(le) {
            return m = le, h = ar(z, n), x ? I(le) : s;
          }
          function k(le) {
            var un = le - d, Cn = le - m, Ao = n - un;
            return E ? ye(Ao, f - Cn) : Ao;
          }
          function U(le) {
            var un = le - d, Cn = le - m;
            return d === i || un >= n || un < 0 || E && Cn >= f;
          }
          function z() {
            var le = ui();
            if (U(le))
              return q(le);
            h = ar(z, k(le));
          }
          function q(le) {
            return h = i, A && r ? I(le) : (r = u = i, s);
          }
          function ke() {
            h !== i && df(h), m = 0, r = d = u = h = i;
          }
          function Ce() {
            return h === i ? s : q(ui());
          }
          function $e() {
            var le = ui(), un = U(le);
            if (r = arguments, u = this, d = le, un) {
              if (h === i)
                return P(d);
              if (E)
                return df(h), h = ar(z, n), I(d);
            }
            return h === i && (h = ar(z, n)), s;
          }
          return $e.cancel = ke, $e.flush = Ce, $e;
        }
        var yg = $(function(e, n) {
          return Ka(e, 1, n);
        }), Rg = $(function(e, n, t) {
          return Ka(e, Xe(n) || 0, t);
        });
        function Ag(e) {
          return yn(e, st);
        }
        function ai(e, n) {
          if (typeof e != "function" || n != null && typeof n != "function")
            throw new Ye(T);
          var t = function() {
            var r = arguments, u = n ? n.apply(this, r) : r[0], f = t.cache;
            if (f.has(u))
              return f.get(u);
            var s = e.apply(this, r);
            return t.cache = f.set(u, s) || f, s;
          };
          return t.cache = new (ai.Cache || xn)(), t;
        }
        ai.Cache = xn;
        function fi(e) {
          if (typeof e != "function")
            throw new Ye(T);
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, n[0]);
              case 2:
                return !e.call(this, n[0], n[1]);
              case 3:
                return !e.call(this, n[0], n[1], n[2]);
            }
            return !e.apply(this, n);
          };
        }
        function Sg(e) {
          return eo(2, e);
        }
        var Tg = hl(function(e, n) {
          n = n.length == 1 && W(n[0]) ? re(n[0], We(O())) : re(Ee(n, 1), We(O()));
          var t = n.length;
          return $(function(r) {
            for (var u = -1, f = ye(r.length, t); ++u < f; )
              r[u] = n[u].call(this, r[u]);
            return Me(e, this, r);
          });
        }), bu = $(function(e, n) {
          var t = Mn(n, Ot(bu));
          return yn(e, Qe, i, n, t);
        }), uo = $(function(e, n) {
          var t = Mn(n, Ot(uo));
          return yn(e, Hn, i, n, t);
        }), Cg = Rn(function(e, n) {
          return yn(e, Yn, i, i, i, n);
        });
        function Ig(e, n) {
          if (typeof e != "function")
            throw new Ye(T);
          return n = n === i ? n : N(n), $(e, n);
        }
        function bg(e, n) {
          if (typeof e != "function")
            throw new Ye(T);
          return n = n == null ? 0 : de(N(n), 0), $(function(t) {
            var r = t[n], u = $n(t, 0, n);
            return r && Fn(u, r), Me(e, this, u);
          });
        }
        function Og(e, n, t) {
          var r = !0, u = !0;
          if (typeof e != "function")
            throw new Ye(T);
          return ue(t) && (r = "leading" in t ? !!t.leading : r, u = "trailing" in t ? !!t.trailing : u), io(e, n, {
            leading: r,
            maxWait: n,
            trailing: u
          });
        }
        function Lg(e) {
          return jf(e, 1);
        }
        function Pg(e, n) {
          return bu(gu(n), e);
        }
        function Ug() {
          if (!arguments.length)
            return [];
          var e = arguments[0];
          return W(e) ? e : [e];
        }
        function Dg(e) {
          return qe(e, oe);
        }
        function Fg(e, n) {
          return n = typeof n == "function" ? n : i, qe(e, oe, n);
        }
        function Mg(e) {
          return qe(e, B | oe);
        }
        function Wg(e, n) {
          return n = typeof n == "function" ? n : i, qe(e, B | oe, n);
        }
        function Ng(e, n) {
          return n == null || Ya(e, n, _e(n));
        }
        function rn(e, n) {
          return e === n || e !== e && n !== n;
        }
        var Bg = jr(nu), kg = jr(function(e, n) {
          return e >= n;
        }), at = Va(/* @__PURE__ */ function() {
          return arguments;
        }()) ? Va : function(e) {
          return fe(e) && Q.call(e, "callee") && !Wa.call(e, "callee");
        }, W = p.isArray, $g = wa ? We(wa) : Jc;
        function Oe(e) {
          return e != null && oi(e.length) && !Sn(e);
        }
        function ce(e) {
          return fe(e) && Oe(e);
        }
        function Gg(e) {
          return e === !0 || e === !1 || fe(e) && Se(e) == on;
        }
        var Gn = tc || ku, zg = ma ? We(ma) : Xc;
        function Hg(e) {
          return fe(e) && e.nodeType === 1 && !fr(e);
        }
        function Yg(e) {
          if (e == null)
            return !0;
          if (Oe(e) && (W(e) || typeof e == "string" || typeof e.splice == "function" || Gn(e) || Lt(e) || at(e)))
            return !e.length;
          var n = Re(e);
          if (n == De || n == Fe)
            return !e.size;
          if (ur(e))
            return !iu(e).length;
          for (var t in e)
            if (Q.call(e, t))
              return !1;
          return !0;
        }
        function Kg(e, n) {
          return tr(e, n);
        }
        function qg(e, n, t) {
          t = typeof t == "function" ? t : i;
          var r = t ? t(e, n) : i;
          return r === i ? tr(e, n, i, t) : !!r;
        }
        function Ou(e) {
          if (!fe(e))
            return !1;
          var n = Se(e);
          return n == lt || n == ct || typeof e.message == "string" && typeof e.name == "string" && !fr(e);
        }
        function Zg(e) {
          return typeof e == "number" && Ba(e);
        }
        function Sn(e) {
          if (!ue(e))
            return !1;
          var n = Se(e);
          return n == Jn || n == wr || n == Dt || n == ht;
        }
        function ao(e) {
          return typeof e == "number" && e == N(e);
        }
        function oi(e) {
          return typeof e == "number" && e > -1 && e % 1 == 0 && e <= pn;
        }
        function ue(e) {
          var n = typeof e;
          return e != null && (n == "object" || n == "function");
        }
        function fe(e) {
          return e != null && typeof e == "object";
        }
        var fo = xa ? We(xa) : Qc;
        function Jg(e, n) {
          return e === n || ru(e, n, xu(n));
        }
        function Xg(e, n, t) {
          return t = typeof t == "function" ? t : i, ru(e, n, xu(n), t);
        }
        function Vg(e) {
          return oo(e) && e != +e;
        }
        function Qg(e) {
          if (Fl(e))
            throw new M(R);
          return Qa(e);
        }
        function jg(e) {
          return e === null;
        }
        function ed(e) {
          return e == null;
        }
        function oo(e) {
          return typeof e == "number" || fe(e) && Se(e) == sn;
        }
        function fr(e) {
          if (!fe(e) || Se(e) != Ge)
            return !1;
          var n = Fr(e);
          if (n === null)
            return !0;
          var t = Q.call(n, "constructor") && n.constructor;
          return typeof t == "function" && t instanceof t && Lr.call(t) == Xs;
        }
        var Lu = Ea ? We(Ea) : jc;
        function nd(e) {
          return ao(e) && e >= -9007199254740991 && e <= pn;
        }
        var so = ya ? We(ya) : el;
        function si(e) {
          return typeof e == "string" || !W(e) && fe(e) && Se(e) == vn;
        }
        function Be(e) {
          return typeof e == "symbol" || fe(e) && Se(e) == gt;
        }
        var Lt = Ra ? We(Ra) : nl;
        function td(e) {
          return e === i;
        }
        function rd(e) {
          return fe(e) && Re(e) == On;
        }
        function id(e) {
          return fe(e) && Se(e) == mr;
        }
        var ud = jr(uu), ad = jr(function(e, n) {
          return e <= n;
        });
        function co(e) {
          if (!e)
            return [];
          if (Oe(e))
            return si(e) ? nn(e) : be(e);
          if (Zt && e[Zt])
            return Ns(e[Zt]());
          var n = Re(e), t = n == De ? Ki : n == Fe ? Ir : Pt;
          return t(e);
        }
        function Tn(e) {
          if (!e)
            return e === 0 ? e : 0;
          if (e = Xe(e), e === qn || e === -1 / 0) {
            var n = e < 0 ? -1 : 1;
            return n * pr;
          }
          return e === e ? e : 0;
        }
        function N(e) {
          var n = Tn(e), t = n % 1;
          return n === n ? t ? n - t : n : 0;
        }
        function lo(e) {
          return e ? tt(N(e), 0, Ue) : 0;
        }
        function Xe(e) {
          if (typeof e == "number")
            return e;
          if (Be(e))
            return Zn;
          if (ue(e)) {
            var n = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = ue(n) ? n + "" : n;
          }
          if (typeof e != "string")
            return e === 0 ? e : +e;
          e = ba(e);
          var t = G.test(e);
          return t || ie.test(e) ? Es(e.slice(2), t ? 2 : 8) : H.test(e) ? Zn : +e;
        }
        function ho(e) {
          return ln(e, Le(e));
        }
        function fd(e) {
          return e ? tt(N(e), -9007199254740991, pn) : e === 0 ? e : 0;
        }
        function V(e) {
          return e == null ? "" : Ne(e);
        }
        var od = It(function(e, n) {
          if (ur(n) || Oe(n)) {
            ln(n, _e(n), e);
            return;
          }
          for (var t in n)
            Q.call(n, t) && jt(e, t, n[t]);
        }), go = It(function(e, n) {
          ln(n, Le(n), e);
        }), ci = It(function(e, n, t, r) {
          ln(n, Le(n), e, r);
        }), sd = It(function(e, n, t, r) {
          ln(n, _e(n), e, r);
        }), cd = Rn(Qi);
        function ld(e, n) {
          var t = Ct(e);
          return n == null ? t : Ha(t, n);
        }
        var hd = $(function(e, n) {
          e = ee(e);
          var t = -1, r = n.length, u = r > 2 ? n[2] : i;
          for (u && Te(n[0], n[1], u) && (r = 1); ++t < r; )
            for (var f = n[t], s = Le(f), h = -1, d = s.length; ++h < d; ) {
              var m = s[h], x = e[m];
              (x === i || rn(x, At[m]) && !Q.call(e, m)) && (e[m] = f[m]);
            }
          return e;
        }), gd = $(function(e) {
          return e.push(i, Of), Me(po, i, e);
        });
        function dd(e, n) {
          return Sa(e, O(n, 3), cn);
        }
        function pd(e, n) {
          return Sa(e, O(n, 3), eu);
        }
        function _d(e, n) {
          return e == null ? e : ji(e, O(n, 3), Le);
        }
        function vd(e, n) {
          return e == null ? e : Ja(e, O(n, 3), Le);
        }
        function wd(e, n) {
          return e && cn(e, O(n, 3));
        }
        function md(e, n) {
          return e && eu(e, O(n, 3));
        }
        function xd(e) {
          return e == null ? [] : Yr(e, _e(e));
        }
        function Ed(e) {
          return e == null ? [] : Yr(e, Le(e));
        }
        function Pu(e, n, t) {
          var r = e == null ? i : rt(e, n);
          return r === i ? t : r;
        }
        function yd(e, n) {
          return e != null && Uf(e, n, Yc);
        }
        function Uu(e, n) {
          return e != null && Uf(e, n, Kc);
        }
        var Rd = Sf(function(e, n, t) {
          n != null && typeof n.toString != "function" && (n = Pr.call(n)), e[n] = t;
        }, Fu(Pe)), Ad = Sf(function(e, n, t) {
          n != null && typeof n.toString != "function" && (n = Pr.call(n)), Q.call(e, n) ? e[n].push(t) : e[n] = [t];
        }, O), Sd = $(nr);
        function _e(e) {
          return Oe(e) ? Ga(e) : iu(e);
        }
        function Le(e) {
          return Oe(e) ? Ga(e, !0) : tl(e);
        }
        function Td(e, n) {
          var t = {};
          return n = O(n, 3), cn(e, function(r, u, f) {
            En(t, n(r, u, f), r);
          }), t;
        }
        function Cd(e, n) {
          var t = {};
          return n = O(n, 3), cn(e, function(r, u, f) {
            En(t, u, n(r, u, f));
          }), t;
        }
        var Id = It(function(e, n, t) {
          Kr(e, n, t);
        }), po = It(function(e, n, t, r) {
          Kr(e, n, t, r);
        }), bd = Rn(function(e, n) {
          var t = {};
          if (e == null)
            return t;
          var r = !1;
          n = re(n, function(f) {
            return f = kn(f, e), r || (r = f.length > 1), f;
          }), ln(e, wu(e), t), r && (t = qe(t, B | j | oe, Rl));
          for (var u = n.length; u--; )
            cu(t, n[u]);
          return t;
        });
        function Od(e, n) {
          return _o(e, fi(O(n)));
        }
        var Ld = Rn(function(e, n) {
          return e == null ? {} : il(e, n);
        });
        function _o(e, n) {
          if (e == null)
            return {};
          var t = re(wu(e), function(r) {
            return [r];
          });
          return n = O(n), af(e, t, function(r, u) {
            return n(r, u[0]);
          });
        }
        function Pd(e, n, t) {
          n = kn(n, e);
          var r = -1, u = n.length;
          for (u || (u = 1, e = i); ++r < u; ) {
            var f = e == null ? i : e[hn(n[r])];
            f === i && (r = u, f = t), e = Sn(f) ? f.call(e) : f;
          }
          return e;
        }
        function Ud(e, n, t) {
          return e == null ? e : rr(e, n, t);
        }
        function Dd(e, n, t, r) {
          return r = typeof r == "function" ? r : i, e == null ? e : rr(e, n, t, r);
        }
        var vo = If(_e), wo = If(Le);
        function Fd(e, n, t) {
          var r = W(e), u = r || Gn(e) || Lt(e);
          if (n = O(n, 4), t == null) {
            var f = e && e.constructor;
            u ? t = r ? new f() : [] : ue(e) ? t = Sn(f) ? Ct(Fr(e)) : {} : t = {};
          }
          return (u ? He : cn)(e, function(s, h, d) {
            return n(t, s, h, d);
          }), t;
        }
        function Md(e, n) {
          return e == null ? !0 : cu(e, n);
        }
        function Wd(e, n, t) {
          return e == null ? e : lf(e, n, gu(t));
        }
        function Nd(e, n, t, r) {
          return r = typeof r == "function" ? r : i, e == null ? e : lf(e, n, gu(t), r);
        }
        function Pt(e) {
          return e == null ? [] : Yi(e, _e(e));
        }
        function Bd(e) {
          return e == null ? [] : Yi(e, Le(e));
        }
        function kd(e, n, t) {
          return t === i && (t = n, n = i), t !== i && (t = Xe(t), t = t === t ? t : 0), n !== i && (n = Xe(n), n = n === n ? n : 0), tt(Xe(e), n, t);
        }
        function $d(e, n, t) {
          return n = Tn(n), t === i ? (t = n, n = 0) : t = Tn(t), e = Xe(e), qc(e, n, t);
        }
        function Gd(e, n, t) {
          if (t && typeof t != "boolean" && Te(e, n, t) && (n = t = i), t === i && (typeof n == "boolean" ? (t = n, n = i) : typeof e == "boolean" && (t = e, e = i)), e === i && n === i ? (e = 0, n = 1) : (e = Tn(e), n === i ? (n = e, e = 0) : n = Tn(n)), e > n) {
            var r = e;
            e = n, n = r;
          }
          if (t || e % 1 || n % 1) {
            var u = ka();
            return ye(e + u * (n - e + xs("1e-" + ((u + "").length - 1))), n);
          }
          return fu(e, n);
        }
        var zd = bt(function(e, n, t) {
          return n = n.toLowerCase(), e + (t ? mo(n) : n);
        });
        function mo(e) {
          return Du(V(e).toLowerCase());
        }
        function xo(e) {
          return e = V(e), e && e.replace(Ie, Us).replace(cs, "");
        }
        function Hd(e, n, t) {
          e = V(e), n = Ne(n);
          var r = e.length;
          t = t === i ? r : tt(N(t), 0, r);
          var u = t;
          return t -= n.length, t >= 0 && e.slice(t, u) == n;
        }
        function Yd(e) {
          return e = V(e), e && yi.test(e) ? e.replace(vt, Ds) : e;
        }
        function Kd(e) {
          return e = V(e), e && Ar.test(e) ? e.replace(wt, "\\$&") : e;
        }
        var qd = bt(function(e, n, t) {
          return e + (t ? "-" : "") + n.toLowerCase();
        }), Zd = bt(function(e, n, t) {
          return e + (t ? " " : "") + n.toLowerCase();
        }), Jd = yf("toLowerCase");
        function Xd(e, n, t) {
          e = V(e), n = N(n);
          var r = n ? yt(e) : 0;
          if (!n || r >= n)
            return e;
          var u = (n - r) / 2;
          return Qr(Br(u), t) + e + Qr(Nr(u), t);
        }
        function Vd(e, n, t) {
          e = V(e), n = N(n);
          var r = n ? yt(e) : 0;
          return n && r < n ? e + Qr(n - r, t) : e;
        }
        function Qd(e, n, t) {
          e = V(e), n = N(n);
          var r = n ? yt(e) : 0;
          return n && r < n ? Qr(n - r, t) + e : e;
        }
        function jd(e, n, t) {
          return t || n == null ? n = 0 : n && (n = +n), ac(V(e).replace(Yt, ""), n || 0);
        }
        function ep(e, n, t) {
          return (t ? Te(e, n, t) : n === i) ? n = 1 : n = N(n), ou(V(e), n);
        }
        function np() {
          var e = arguments, n = V(e[0]);
          return e.length < 3 ? n : n.replace(e[1], e[2]);
        }
        var tp = bt(function(e, n, t) {
          return e + (t ? "_" : "") + n.toLowerCase();
        });
        function rp(e, n, t) {
          return t && typeof t != "number" && Te(e, n, t) && (n = t = i), t = t === i ? Ue : t >>> 0, t ? (e = V(e), e && (typeof n == "string" || n != null && !Lu(n)) && (n = Ne(n), !n && Et(e)) ? $n(nn(e), 0, t) : e.split(n, t)) : [];
        }
        var ip = bt(function(e, n, t) {
          return e + (t ? " " : "") + Du(n);
        });
        function up(e, n, t) {
          return e = V(e), t = t == null ? 0 : tt(N(t), 0, e.length), n = Ne(n), e.slice(t, t + n.length) == n;
        }
        function ap(e, n, t) {
          var r = a.templateSettings;
          t && Te(e, n, t) && (n = i), e = V(e), n = ci({}, n, r, bf);
          var u = ci({}, n.imports, r.imports, bf), f = _e(u), s = Yi(u, f), h, d, m = 0, x = n.interpolate || en, E = "__p += '", A = qi(
            (n.escape || en).source + "|" + x.source + "|" + (x === Ht ? Z : en).source + "|" + (n.evaluate || en).source + "|$",
            "g"
          ), I = "//# sourceURL=" + (Q.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ps + "]") + `
`;
          e.replace(A, function(U, z, q, ke, Ce, $e) {
            return q || (q = ke), E += e.slice(m, $e).replace(wn, Fs), z && (h = !0, E += `' +
__e(` + z + `) +
'`), Ce && (d = !0, E += `';
` + Ce + `;
__p += '`), q && (E += `' +
((__t = (` + q + `)) == null ? '' : __t) +
'`), m = $e + U.length, U;
          }), E += `';
`;
          var P = Q.call(n, "variable") && n.variable;
          if (!P)
            E = `with (obj) {
` + E + `
}
`;
          else if (S.test(P))
            throw new M(F);
          E = (d ? E.replace(zt, "") : E).replace(xr, "$1").replace(Un, "$1;"), E = "function(" + (P || "obj") + `) {
` + (P ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (h ? ", __e = _.escape" : "") + (d ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + E + `return __p
}`;
          var k = yo(function() {
            return J(f, I + "return " + E).apply(i, s);
          });
          if (k.source = E, Ou(k))
            throw k;
          return k;
        }
        function fp(e) {
          return V(e).toLowerCase();
        }
        function op(e) {
          return V(e).toUpperCase();
        }
        function sp(e, n, t) {
          if (e = V(e), e && (t || n === i))
            return ba(e);
          if (!e || !(n = Ne(n)))
            return e;
          var r = nn(e), u = nn(n), f = Oa(r, u), s = La(r, u) + 1;
          return $n(r, f, s).join("");
        }
        function cp(e, n, t) {
          if (e = V(e), e && (t || n === i))
            return e.slice(0, Ua(e) + 1);
          if (!e || !(n = Ne(n)))
            return e;
          var r = nn(e), u = La(r, nn(n)) + 1;
          return $n(r, 0, u).join("");
        }
        function lp(e, n, t) {
          if (e = V(e), e && (t || n === i))
            return e.replace(Yt, "");
          if (!e || !(n = Ne(n)))
            return e;
          var r = nn(e), u = Oa(r, nn(n));
          return $n(r, u).join("");
        }
        function hp(e, n) {
          var t = wi, r = mi;
          if (ue(n)) {
            var u = "separator" in n ? n.separator : u;
            t = "length" in n ? N(n.length) : t, r = "omission" in n ? Ne(n.omission) : r;
          }
          e = V(e);
          var f = e.length;
          if (Et(e)) {
            var s = nn(e);
            f = s.length;
          }
          if (t >= f)
            return e;
          var h = t - yt(r);
          if (h < 1)
            return r;
          var d = s ? $n(s, 0, h).join("") : e.slice(0, h);
          if (u === i)
            return d + r;
          if (s && (h += d.length - h), Lu(u)) {
            if (e.slice(h).search(u)) {
              var m, x = d;
              for (u.global || (u = qi(u.source, V(X.exec(u)) + "g")), u.lastIndex = 0; m = u.exec(x); )
                var E = m.index;
              d = d.slice(0, E === i ? h : E);
            }
          } else if (e.indexOf(Ne(u), h) != h) {
            var A = d.lastIndexOf(u);
            A > -1 && (d = d.slice(0, A));
          }
          return d + r;
        }
        function gp(e) {
          return e = V(e), e && Er.test(e) ? e.replace(_t, Gs) : e;
        }
        var dp = bt(function(e, n, t) {
          return e + (t ? " " : "") + n.toUpperCase();
        }), Du = yf("toUpperCase");
        function Eo(e, n, t) {
          return e = V(e), n = t ? i : n, n === i ? Ws(e) ? Ys(e) : Is(e) : e.match(n) || [];
        }
        var yo = $(function(e, n) {
          try {
            return Me(e, i, n);
          } catch (t) {
            return Ou(t) ? t : new M(t);
          }
        }), pp = Rn(function(e, n) {
          return He(n, function(t) {
            t = hn(t), En(e, t, Iu(e[t], e));
          }), e;
        });
        function _p(e) {
          var n = e == null ? 0 : e.length, t = O();
          return e = n ? re(e, function(r) {
            if (typeof r[1] != "function")
              throw new Ye(T);
            return [t(r[0]), r[1]];
          }) : [], $(function(r) {
            for (var u = -1; ++u < n; ) {
              var f = e[u];
              if (Me(f[0], this, r))
                return Me(f[1], this, r);
            }
          });
        }
        function vp(e) {
          return Gc(qe(e, B));
        }
        function Fu(e) {
          return function() {
            return e;
          };
        }
        function wp(e, n) {
          return e == null || e !== e ? n : e;
        }
        var mp = Af(), xp = Af(!0);
        function Pe(e) {
          return e;
        }
        function Mu(e) {
          return ja(typeof e == "function" ? e : qe(e, B));
        }
        function Ep(e) {
          return nf(qe(e, B));
        }
        function yp(e, n) {
          return tf(e, qe(n, B));
        }
        var Rp = $(function(e, n) {
          return function(t) {
            return nr(t, e, n);
          };
        }), Ap = $(function(e, n) {
          return function(t) {
            return nr(e, t, n);
          };
        });
        function Wu(e, n, t) {
          var r = _e(n), u = Yr(n, r);
          t == null && !(ue(n) && (u.length || !r.length)) && (t = n, n = e, e = this, u = Yr(n, _e(n)));
          var f = !(ue(t) && "chain" in t) || !!t.chain, s = Sn(e);
          return He(u, function(h) {
            var d = n[h];
            e[h] = d, s && (e.prototype[h] = function() {
              var m = this.__chain__;
              if (f || m) {
                var x = e(this.__wrapped__), E = x.__actions__ = be(this.__actions__);
                return E.push({ func: d, args: arguments, thisArg: e }), x.__chain__ = m, x;
              }
              return d.apply(e, Fn([this.value()], arguments));
            });
          }), e;
        }
        function Sp() {
          return xe._ === this && (xe._ = Vs), this;
        }
        function Nu() {
        }
        function Tp(e) {
          return e = N(e), $(function(n) {
            return rf(n, e);
          });
        }
        var Cp = pu(re), Ip = pu(Aa), bp = pu(ki);
        function Ro(e) {
          return yu(e) ? $i(hn(e)) : ul(e);
        }
        function Op(e) {
          return function(n) {
            return e == null ? i : rt(e, n);
          };
        }
        var Lp = Tf(), Pp = Tf(!0);
        function Bu() {
          return [];
        }
        function ku() {
          return !1;
        }
        function Up() {
          return {};
        }
        function Dp() {
          return "";
        }
        function Fp() {
          return !0;
        }
        function Mp(e, n) {
          if (e = N(e), e < 1 || e > pn)
            return [];
          var t = Ue, r = ye(e, Ue);
          n = O(n), e -= Ue;
          for (var u = Hi(r, n); ++t < e; )
            n(t);
          return u;
        }
        function Wp(e) {
          return W(e) ? re(e, hn) : Be(e) ? [e] : be(Gf(V(e)));
        }
        function Np(e) {
          var n = ++Js;
          return V(e) + n;
        }
        var Bp = Vr(function(e, n) {
          return e + n;
        }, 0), kp = _u("ceil"), $p = Vr(function(e, n) {
          return e / n;
        }, 1), Gp = _u("floor");
        function zp(e) {
          return e && e.length ? Hr(e, Pe, nu) : i;
        }
        function Hp(e, n) {
          return e && e.length ? Hr(e, O(n, 2), nu) : i;
        }
        function Yp(e) {
          return Ca(e, Pe);
        }
        function Kp(e, n) {
          return Ca(e, O(n, 2));
        }
        function qp(e) {
          return e && e.length ? Hr(e, Pe, uu) : i;
        }
        function Zp(e, n) {
          return e && e.length ? Hr(e, O(n, 2), uu) : i;
        }
        var Jp = Vr(function(e, n) {
          return e * n;
        }, 1), Xp = _u("round"), Vp = Vr(function(e, n) {
          return e - n;
        }, 0);
        function Qp(e) {
          return e && e.length ? zi(e, Pe) : 0;
        }
        function jp(e, n) {
          return e && e.length ? zi(e, O(n, 2)) : 0;
        }
        return a.after = Eg, a.ary = jf, a.assign = od, a.assignIn = go, a.assignInWith = ci, a.assignWith = sd, a.at = cd, a.before = eo, a.bind = Iu, a.bindAll = pp, a.bindKey = no, a.castArray = Ug, a.chain = Xf, a.chunk = Gl, a.compact = zl, a.concat = Hl, a.cond = _p, a.conforms = vp, a.constant = Fu, a.countBy = Qh, a.create = ld, a.curry = to, a.curryRight = ro, a.debounce = io, a.defaults = hd, a.defaultsDeep = gd, a.defer = yg, a.delay = Rg, a.difference = Yl, a.differenceBy = Kl, a.differenceWith = ql, a.drop = Zl, a.dropRight = Jl, a.dropRightWhile = Xl, a.dropWhile = Vl, a.fill = Ql, a.filter = eg, a.flatMap = rg, a.flatMapDeep = ig, a.flatMapDepth = ug, a.flatten = Kf, a.flattenDeep = jl, a.flattenDepth = eh, a.flip = Ag, a.flow = mp, a.flowRight = xp, a.fromPairs = nh, a.functions = xd, a.functionsIn = Ed, a.groupBy = ag, a.initial = rh, a.intersection = ih, a.intersectionBy = uh, a.intersectionWith = ah, a.invert = Rd, a.invertBy = Ad, a.invokeMap = og, a.iteratee = Mu, a.keyBy = sg, a.keys = _e, a.keysIn = Le, a.map = ii, a.mapKeys = Td, a.mapValues = Cd, a.matches = Ep, a.matchesProperty = yp, a.memoize = ai, a.merge = Id, a.mergeWith = po, a.method = Rp, a.methodOf = Ap, a.mixin = Wu, a.negate = fi, a.nthArg = Tp, a.omit = bd, a.omitBy = Od, a.once = Sg, a.orderBy = cg, a.over = Cp, a.overArgs = Tg, a.overEvery = Ip, a.overSome = bp, a.partial = bu, a.partialRight = uo, a.partition = lg, a.pick = Ld, a.pickBy = _o, a.property = Ro, a.propertyOf = Op, a.pull = ch, a.pullAll = Zf, a.pullAllBy = lh, a.pullAllWith = hh, a.pullAt = gh, a.range = Lp, a.rangeRight = Pp, a.rearg = Cg, a.reject = dg, a.remove = dh, a.rest = Ig, a.reverse = Tu, a.sampleSize = _g, a.set = Ud, a.setWith = Dd, a.shuffle = vg, a.slice = ph, a.sortBy = xg, a.sortedUniq = yh, a.sortedUniqBy = Rh, a.split = rp, a.spread = bg, a.tail = Ah, a.take = Sh, a.takeRight = Th, a.takeRightWhile = Ch, a.takeWhile = Ih, a.tap = zh, a.throttle = Og, a.thru = ri, a.toArray = co, a.toPairs = vo, a.toPairsIn = wo, a.toPath = Wp, a.toPlainObject = ho, a.transform = Fd, a.unary = Lg, a.union = bh, a.unionBy = Oh, a.unionWith = Lh, a.uniq = Ph, a.uniqBy = Uh, a.uniqWith = Dh, a.unset = Md, a.unzip = Cu, a.unzipWith = Jf, a.update = Wd, a.updateWith = Nd, a.values = Pt, a.valuesIn = Bd, a.without = Fh, a.words = Eo, a.wrap = Pg, a.xor = Mh, a.xorBy = Wh, a.xorWith = Nh, a.zip = Bh, a.zipObject = kh, a.zipObjectDeep = $h, a.zipWith = Gh, a.entries = vo, a.entriesIn = wo, a.extend = go, a.extendWith = ci, Wu(a, a), a.add = Bp, a.attempt = yo, a.camelCase = zd, a.capitalize = mo, a.ceil = kp, a.clamp = kd, a.clone = Dg, a.cloneDeep = Mg, a.cloneDeepWith = Wg, a.cloneWith = Fg, a.conformsTo = Ng, a.deburr = xo, a.defaultTo = wp, a.divide = $p, a.endsWith = Hd, a.eq = rn, a.escape = Yd, a.escapeRegExp = Kd, a.every = jh, a.find = ng, a.findIndex = Hf, a.findKey = dd, a.findLast = tg, a.findLastIndex = Yf, a.findLastKey = pd, a.floor = Gp, a.forEach = Vf, a.forEachRight = Qf, a.forIn = _d, a.forInRight = vd, a.forOwn = wd, a.forOwnRight = md, a.get = Pu, a.gt = Bg, a.gte = kg, a.has = yd, a.hasIn = Uu, a.head = qf, a.identity = Pe, a.includes = fg, a.indexOf = th, a.inRange = $d, a.invoke = Sd, a.isArguments = at, a.isArray = W, a.isArrayBuffer = $g, a.isArrayLike = Oe, a.isArrayLikeObject = ce, a.isBoolean = Gg, a.isBuffer = Gn, a.isDate = zg, a.isElement = Hg, a.isEmpty = Yg, a.isEqual = Kg, a.isEqualWith = qg, a.isError = Ou, a.isFinite = Zg, a.isFunction = Sn, a.isInteger = ao, a.isLength = oi, a.isMap = fo, a.isMatch = Jg, a.isMatchWith = Xg, a.isNaN = Vg, a.isNative = Qg, a.isNil = ed, a.isNull = jg, a.isNumber = oo, a.isObject = ue, a.isObjectLike = fe, a.isPlainObject = fr, a.isRegExp = Lu, a.isSafeInteger = nd, a.isSet = so, a.isString = si, a.isSymbol = Be, a.isTypedArray = Lt, a.isUndefined = td, a.isWeakMap = rd, a.isWeakSet = id, a.join = fh, a.kebabCase = qd, a.last = Je, a.lastIndexOf = oh, a.lowerCase = Zd, a.lowerFirst = Jd, a.lt = ud, a.lte = ad, a.max = zp, a.maxBy = Hp, a.mean = Yp, a.meanBy = Kp, a.min = qp, a.minBy = Zp, a.stubArray = Bu, a.stubFalse = ku, a.stubObject = Up, a.stubString = Dp, a.stubTrue = Fp, a.multiply = Jp, a.nth = sh, a.noConflict = Sp, a.noop = Nu, a.now = ui, a.pad = Xd, a.padEnd = Vd, a.padStart = Qd, a.parseInt = jd, a.random = Gd, a.reduce = hg, a.reduceRight = gg, a.repeat = ep, a.replace = np, a.result = Pd, a.round = Xp, a.runInContext = g, a.sample = pg, a.size = wg, a.snakeCase = tp, a.some = mg, a.sortedIndex = _h, a.sortedIndexBy = vh, a.sortedIndexOf = wh, a.sortedLastIndex = mh, a.sortedLastIndexBy = xh, a.sortedLastIndexOf = Eh, a.startCase = ip, a.startsWith = up, a.subtract = Vp, a.sum = Qp, a.sumBy = jp, a.template = ap, a.times = Mp, a.toFinite = Tn, a.toInteger = N, a.toLength = lo, a.toLower = fp, a.toNumber = Xe, a.toSafeInteger = fd, a.toString = V, a.toUpper = op, a.trim = sp, a.trimEnd = cp, a.trimStart = lp, a.truncate = hp, a.unescape = gp, a.uniqueId = Np, a.upperCase = dp, a.upperFirst = Du, a.each = Vf, a.eachRight = Qf, a.first = qf, Wu(a, function() {
          var e = {};
          return cn(a, function(n, t) {
            Q.call(a.prototype, t) || (e[t] = n);
          }), e;
        }(), { chain: !1 }), a.VERSION = _, He(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
          a[e].placeholder = a;
        }), He(["drop", "take"], function(e, n) {
          Y.prototype[e] = function(t) {
            t = t === i ? 1 : de(N(t), 0);
            var r = this.__filtered__ && !n ? new Y(this) : this.clone();
            return r.__filtered__ ? r.__takeCount__ = ye(t, r.__takeCount__) : r.__views__.push({
              size: ye(t, Ue),
              type: e + (r.__dir__ < 0 ? "Right" : "")
            }), r;
          }, Y.prototype[e + "Right"] = function(t) {
            return this.reverse()[e](t).reverse();
          };
        }), He(["filter", "map", "takeWhile"], function(e, n) {
          var t = n + 1, r = t == fn || t == dr;
          Y.prototype[e] = function(u) {
            var f = this.clone();
            return f.__iteratees__.push({
              iteratee: O(u, 3),
              type: t
            }), f.__filtered__ = f.__filtered__ || r, f;
          };
        }), He(["head", "last"], function(e, n) {
          var t = "take" + (n ? "Right" : "");
          Y.prototype[e] = function() {
            return this[t](1).value()[0];
          };
        }), He(["initial", "tail"], function(e, n) {
          var t = "drop" + (n ? "" : "Right");
          Y.prototype[e] = function() {
            return this.__filtered__ ? new Y(this) : this[t](1);
          };
        }), Y.prototype.compact = function() {
          return this.filter(Pe);
        }, Y.prototype.find = function(e) {
          return this.filter(e).head();
        }, Y.prototype.findLast = function(e) {
          return this.reverse().find(e);
        }, Y.prototype.invokeMap = $(function(e, n) {
          return typeof e == "function" ? new Y(this) : this.map(function(t) {
            return nr(t, e, n);
          });
        }), Y.prototype.reject = function(e) {
          return this.filter(fi(O(e)));
        }, Y.prototype.slice = function(e, n) {
          e = N(e);
          var t = this;
          return t.__filtered__ && (e > 0 || n < 0) ? new Y(t) : (e < 0 ? t = t.takeRight(-e) : e && (t = t.drop(e)), n !== i && (n = N(n), t = n < 0 ? t.dropRight(-n) : t.take(n - e)), t);
        }, Y.prototype.takeRightWhile = function(e) {
          return this.reverse().takeWhile(e).reverse();
        }, Y.prototype.toArray = function() {
          return this.take(Ue);
        }, cn(Y.prototype, function(e, n) {
          var t = /^(?:filter|find|map|reject)|While$/.test(n), r = /^(?:head|last)$/.test(n), u = a[r ? "take" + (n == "last" ? "Right" : "") : n], f = r || /^find/.test(n);
          u && (a.prototype[n] = function() {
            var s = this.__wrapped__, h = r ? [1] : arguments, d = s instanceof Y, m = h[0], x = d || W(s), E = function(z) {
              var q = u.apply(a, Fn([z], h));
              return r && A ? q[0] : q;
            };
            x && t && typeof m == "function" && m.length != 1 && (d = x = !1);
            var A = this.__chain__, I = !!this.__actions__.length, P = f && !A, k = d && !I;
            if (!f && x) {
              s = k ? s : new Y(this);
              var U = e.apply(s, h);
              return U.__actions__.push({ func: ri, args: [E], thisArg: i }), new Ke(U, A);
            }
            return P && k ? e.apply(this, h) : (U = this.thru(E), P ? r ? U.value()[0] : U.value() : U);
          });
        }), He(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
          var n = br[e], t = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", r = /^(?:pop|shift)$/.test(e);
          a.prototype[e] = function() {
            var u = arguments;
            if (r && !this.__chain__) {
              var f = this.value();
              return n.apply(W(f) ? f : [], u);
            }
            return this[t](function(s) {
              return n.apply(W(s) ? s : [], u);
            });
          };
        }), cn(Y.prototype, function(e, n) {
          var t = a[n];
          if (t) {
            var r = t.name + "";
            Q.call(Tt, r) || (Tt[r] = []), Tt[r].push({ name: n, func: t });
          }
        }), Tt[Xr(i, Ae).name] = [{
          name: "wrapper",
          func: i
        }], Y.prototype.clone = gc, Y.prototype.reverse = dc, Y.prototype.value = pc, a.prototype.at = Hh, a.prototype.chain = Yh, a.prototype.commit = Kh, a.prototype.next = qh, a.prototype.plant = Jh, a.prototype.reverse = Xh, a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = Vh, a.prototype.first = a.prototype.head, Zt && (a.prototype[Zt] = Zh), a;
      }, Rt = Ks();
      Qn ? ((Qn.exports = Rt)._ = Rt, Mi._ = Rt) : xe._ = Rt;
    }).call(J_);
  }(lr, lr.exports)), lr.exports;
}
var V_ = X_();
const cv = ({ children: c, redirectUrl: o = "/" }) => {
  const i = r_(), [_] = i_(), w = Z_(), R = Ko(), T = ft(Zo), F = ft(G_);
  return pi(() => {
    let b = !1;
    const K = _.get("code");
    if (K && w) {
      const L = sessionStorage.getItem("code_verifier");
      if (V_.isEmpty(L)) {
        w.signIn("/dashboard");
        return;
      }
      const B = w.configuration.clientId, j = w == null ? void 0 : w.getBaseUrl();
      w.getConfigurationEndpoints().then((oe) => {
        b || R(
          Hu({
            clientId: B,
            redirectUri: w.configuration.redirectUri,
            tokenEndpoint: oe.tokenEndpoint,
            baseUrl: j,
            code: K
          })
        );
      });
    }
    return () => {
      b = !0;
    };
  }, []), pi(() => {
    T && !F && i((w == null ? void 0 : w.getSavedRedirectUrl()) || o);
  }, [T, F]), /* @__PURE__ */ Ku.jsx(Ku.Fragment, { children: c });
};
export {
  Ut as AuthAdapter,
  cv as AuthCallbackComponent,
  Jo as AuthContext,
  sv as AuthProvider,
  dn as AuthTypeError,
  gn as SessionStatus,
  tv as XORCipher,
  So as XOR_KEY,
  Yu as appDispatch,
  av as authError,
  ov as authReducer,
  qo as authSlice,
  iv as authorize,
  h_ as calculateTokenRenewalTime,
  c_ as clearApplicationStorage,
  Hu as codeCallback,
  ot as generateSerilizadError,
  Ju as getAdjustedClientTime,
  Ko as getAppDispatch,
  di as getNewToken,
  o_ as getSessionStatus,
  Zu as getTokenExpirationDate,
  l_ as getTokenIssuedDateInMs,
  f_ as hasActiveSession,
  s_ as hasValidToken,
  hr as login,
  uv as logout,
  d_ as pkceChallenge,
  G_ as selectAuthIsPending,
  z_ as selectError,
  Zo as selectIsAuthenticated,
  k_ as selectIsRefreshTokenLoading,
  fv as selectIsUserInitialLogin,
  $_ as selectLoginTimestamp,
  H_ as selectRefreshError,
  rv as setupAppDispatch,
  B_ as startLoading,
  Go as storeToken,
  zo as urlSafeBase64Encode,
  Z_ as useAuthContext
};
//# sourceMappingURL=main.js.map
